import { CollectionPoint, GeoPoint } from './../interface/pudo-location.interface';

import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Modal } from 'ngx-modal';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../common/pipes/currency-format.pipe';
import { TitleCasePipe } from '../../common/pipes/title-case.pipe';
import { TranslateKey } from '../../common/pipes/translate-key.pipe';
import { Language } from '../../shared/components/ILanguage';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from "../../shared/constants/common.constants";
import { AddressVisibility } from '../../shared/interface/address-visibility';
import { Country } from '../../shared/interface/country.interface';
import { DisplayPriceConfig } from '../../shared/interface/display-price-config.interface';
import { MemberAllowedCountries } from '../../shared/interface/member-allowed-countries.interface';
import { Member } from '../../shared/interface/member.interface';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { WholesaleQualifiedResponse } from '../../shared/interface/wholesaleQualifiedResponse.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MemberDisplayPriceConfigService } from '../../shared/services/member-display-price-config.service';
import { MessageService } from '../../shared/services/message.service';
import { Utils } from '../../shared/Utils/utils';
import { SSO } from '../../sso/sso.constants';
import { Constants, DelivaryOptionType, IsoCodeThree, MemberType, ProductSource } from '../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, RowStatus } from '../common/enumerations';
import { DateConstants } from '../constants/date.constants';
import { PaymentConstants } from '../constants/payment.constants';
import { PortalDisplayPage } from '../constants/portal-display-page.enum';
import { StatusConstants } from '../constants/status.constants';
import { Translations } from '../constants/translations.constants';
import { CartTypes } from '../enums/cart-type.enum';
import { ImageType } from '../enums/image-type.enum';
import { MemberOrderType } from '../enums/member-order-type.enum';
import { MemberStatus } from '../enums/member-status.enum';
import { MemberTitleExtEnums } from '../enums/member-title.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MessageTypeEnum } from '../enums/message-type.enums';
import { NotificationType } from '../enums/notification-types.enum';
import {
    AddressType, OrderSourceType,
    OrderStatus, PaymentMethodTypes, PaymentType, PriceType,
    ProductWeightMetric, PurchaseFlows,
    PurchaseFlowType, ShippingOrderType, ShippingType, Source
} from '../enums/order-source-type';
import { OrderSourceTypes, OrderSourceValue } from '../enums/order-source.enum';
import { ProductMetatDataValue } from '../enums/product-metadata.enum';
import { SelectEnum } from '../enums/selection.enum';
import { ShippingMemberTitle } from '../enums/shipping-member-title.enum';
import { ShippingMemberType } from '../enums/shipping-member-type.enum';
import { ValueType } from '../enums/value-type.enum';
import { Address } from '../interface/address';
import { AppCountryConfig } from '../interface/app-config';
import { CheckoutConfig } from '../interface/checkout-config.interface';
import { DiscountPercentageResponse } from '../interface/discount-percentage.response.interface';
import {
    EnrollInfo,
    LegalRequirements, MemberCommunicationPreference, Order, PersonalInformation, SponsorInformation
} from '../interface/enrollment';
import { FBOBusinessEntity } from '../interface/fbo-business-entity';
import { MemebrCCOverrideResponse } from '../interface/member-ccoverride-response.interface';
import { MemberLevelHistory } from '../interface/member-level-history.interface';
import { MemberOrderCCInfo } from '../interface/member-order-cc-info';
import { AddressService } from '../services/address.service';
import { OrderRulesRequest } from '../interface/order-rules-request.interface';
import { OrderRulesResponse } from '../interface/order-rules-response.interface';
import { PriceTierResponse } from '../interface/price-tier-response';
import { Product } from '../interface/product-info';
import { ProductModel, ProductRestrictionModel } from '../interface/product-restriction.interface';
import { RestrictedProduct } from '../interface/restricted-product.interface';
import { ShippingMethod } from '../interface/ship-method';
import { ShippingAddressInfoConfig } from '../interface/shipping-address-info-config.interface';
import { ShippingOptionsRequest } from '../interface/shipping-options-request';
import { ShippingOptionsResponse } from '../interface/shipping-options-response';
import { ShippingProductModel } from '../interface/shipping-product.interface';
import { SponsorConfig } from '../interface/sponsor-config.interface';
import { Cart } from '../models/cart.model';
import { DeleteModal } from '../models/delete-modal';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { PaymentComponentSettings } from '../models/payments/payment.model';
import { AppConfigService } from '../services/app-config.service';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { CustomerService } from '../services/customer.service';
import { DocumentService } from '../services/document.service';
import { EnrollmentMessageService } from '../services/enrollment-message.service';
import { OrderService } from '../services/order.service';
import { ShippingAddressInfoConfigService } from '../services/shipping-config.service';
import { SponsorConfigService } from '../services/sponsor-config.service';
import { PudoLocationRequest } from '../interface/pudo-location-request.interface';
import { BusinessHour, SplitHour } from '../interface/business-hour.interface';
import { ContactTypeValue } from '../../common/enums/contact-type.value.enum';
import { MaskPipe } from 'ngx-mask';
import { MemberContact } from '../interface/member-contact';
import { GroupByPipe } from '../../common/pipes/group-by.pipe';
import { PersonalInfoConfigService } from '../services/personal-info-config.service';
import { AccountRestrictionStatus } from "../../common/enums/account-restricted.enum";
import { Subscription } from 'rxjs';
import { transactional } from '../enums/sponsor-transactional-source-type.enum';

@Component({
    selector: 'app-service-order',
    templateUrl: '../templates/template1/views/service-order.component.html',
    styleUrls: [
        '../templates/template1/themes/default/less/service-order.component.less', '../templates/template1/themes/default/less/print-preview.less'
    ],
    providers: [TitleCasePipe]
})
export class ServiceOrderComponent implements OnInit {
    @Input() fboid: string;
    @Output() serviceOrderMemberDetails = new EventEmitter<any>();
    @Input() orderFromLookup: boolean;
    @Input() hasPersistedMemberId: boolean;
    @Output() orderFromLookupEmit = new EventEmitter<any>();
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    showAddressFormValidations = false;
    cartMessageID: any;
    memberInfo: any;
    memberTypeId: any;
    memberTypeEnum = MemberTypeEnum;
    orderType: any = OrderType;
    deliveryPreference: any = DeliveryPreference;
    orderFormGroup: FormGroup;
    fboUpgradeForm: FormGroup;
    items: any[] = [];
    countries: any[] = [];
    memberCountries: any[] = [];
    agentAllowedCountries: any = [];
    states: any[] = [];
    memberSearchSubmitted = false;
    memberAddressDetails: any[] = [];
    memberShippingDetails: any[] = [];
    shippingAddressInfo: any;
    address: any;
    pudoAddress: any;
    countryTaxInclusive: boolean;
    storeInfo: StoreConfig;
    shipMethodValidation: any = '';
    verifiedShippingAddressId: number;
    fpcOrderGlobalUrl: string;
    shippingDeliveryOptionAvailable = false;
    pickupDeliveryOptionAvailable = false;
    agreementCheckError: boolean;
    formSubmitted: boolean;
    defaultCurrency = CommonConstant.Default_Currency;
    governmentIdExist: boolean;
    subTotal = 0.0;
    retailSubTotal = 0.0;
    totalCommissionableVolume = 0;
    selectedIsoCountryCode: any = '';
    selectedCountryCodeTwo = '';
    shipMethods: ShippingOptionsResponse;
    shippingMethods: ShippingMethod[] = [];

    deleteModal: DeleteModal;
    products: any[] = [];
    isSubmitted = false;
    orderTaxResponse: any;
    taxableAmount = 0;
    shippingCost = 0;
    orginalShippingCost = 0;
    searchReqValues: any;
    shipMethod: any = {};
    showSelectedShipMethod = false;
    languageCode = 'en-US';
    languageShortCode = 'en';
    pollCount = 0;
    maxPollCount = 15;
    importFeeValue = 0;
    selectEnum = SelectEnum;
    userInfo: UserInfo;
    memberStatus;
    isActive;
    storeId: number;
    service_Order_show: boolean;
    gstTax: number;
    pstTax: number;
    storeDefaultLanguage: string;
    taxCalculationStatus: boolean;
    minMaxPriceValidation: boolean;
    isFocused: boolean;
    datePickerStartDateAt = new Date();
    invalidGovernmentId: boolean;
    governmentIdValidInProgress: boolean;
    optInCheck = true;
    selectedpickup: number;
    displayPriceConfig: DisplayPriceConfig;
    memberLevelHistory: MemberLevelHistory[];
    isMemberFboUpgraded = false;
    cityList: any = [];
    upgradeFboLimitExceeded = false;
    isFBOValidationPending = false;
    accountMemberInfo: any;
    orderSessionGuid: string;
    isWhosaleCheckNotCalculated = false;
    serviceOrderTypePermissions: number[] = [
        Permission.REPLACEMENT_ORDER_CREATE,
        Permission.REPLACEMENT_ORDER_MANAGE,

    ];

    @ViewChild('shipMethodId') shipMethodId: ElementRef;
    @ViewChild('paymentFormBtn') paymentFormBtn: ElementRef;
    @ViewChild('showRestrictedProducts') showRestrictedProducts: Modal;
    @ViewChild('outOfStockModal') outOfStockModal: Modal;
    @ViewChild('savedAddress') savedAddressElement: ElementRef;
    @ViewChild('addNewAddressEle') addNewAddressEle: ElementRef;
    @ViewChild('seachItemElement') seachItemElement: ElementRef;
    @ViewChild('itemLevelSearch') itemLevelSearch: ElementRef;
    billingAddressInfo: any;
    paymentComponentSettings: PaymentComponentSettings = new PaymentComponentSettings();
    memberId: number;
    countryCode: string;
    addNewpayvisionCard: boolean;
    selectedpayvisionCardInfo: any;
    orderSession: any = {};
    isOrderSessionInfo: boolean;
    createOrderInfo: any;
    restrictedProducts: Array<String>;
    shippingAddressInfoConfig: ShippingAddressInfoConfig;
    checkoutConfig: CheckoutConfig;
    appConfig: AppCountryConfig;
    skipAddressVerification: boolean;
    shippingSchemaUrl: string;
    billingSchemaUrl: string;
    showShippingData: boolean;
    showSavedAddress: boolean;
    showAddressForm: boolean;
    savedAddressId: number;
    savedPudoAddressId: number;
    storePaymentInfo;
    enableBackDateOrder = false;
    thresholdCrossed: boolean;
    memberCCLimitExceeded: boolean;
    orderRules: OrderRulesResponse;
    memberOrderCCInfo: MemberOrderCCInfo;
    personalDiscountPercentage: number;
    productErrorMsg: string;
    savePaymentMethod: boolean;
    monthlyCCValue: number;
    isNewCard: Boolean = false;
    memberCCOverride: MemebrCCOverrideResponse;
    memberCCOverrideLimitExceeded: boolean;
    memberCart: Cart;
    memberCartInfo: Cart;
    shoppingCartCount = 0;
    itemCount = 0;
    existingItemCount = 0;
    isRestrictionPopupOpened: boolean;
    shoppingBagClicked: boolean;
    outOfStockItems: Product[];
    stores: Country[];
    storeLanguages: Language[];
    personalInformation: PersonalInformation;
    sponsorInformation: SponsorInformation;
    mailingSchemaUrl: string;
    displayMailingAddressForm: boolean;
    mailingAddress: Address;
    memberCommunicationPreferences: MemberCommunicationPreference = {
        email: null,
        phone: false
    };
    liveFormAddress: Address;
    orderTypeSelectedValue: number;
    liveFormPersonalInfo: PersonalInformation;
    distributorMaxCC: number;
    existingCC: number;
    memberDiscountPercentage: DiscountPercentageResponse;
    memberCartSessionGuid: string;
    showShippingAddress = true;
    addNewCardClicked: boolean;
    isMemberHasAccessToOrder = true;
    restrictedDays = 0;
    cartLimitExceed = false;
    cartLimitNotReach = false;
    sponsorConfig: SponsorConfig;
    paymentTypeEnum = PaymentType;

    shippingTax: number;
    memberShippingDiscountOfferEligible = false;
    originalShippingTax: number;
    shippingAddressChanged: boolean;
    orderTypePrevValue: number;
    updateCartProduct: number;
    addressSearchResult: any[] = [];
    businessEntityId: number;
    serviceOrderPermissions: boolean;
    operatingCountries = [];
    selectedPudoCollectionPoint: CollectionPoint = null;
    pudoShippingMethod: ShippingMethod = null;
    pudoLocationsNotFound: boolean = false;
    pudoCollectionPoints: CollectionPoint[] = null;
    pudoShippingAddressInfo: Address = null;
    showPudoPickupPersonAddressForm: boolean = false;
    memberBasicInfo: any;
    pudoLocationSearchForm: FormGroup;
    loadingPudoPickupLocations: boolean;
    displayPudoAddress: boolean;
    pudoAddressSubmitted: boolean;
    homeCountry: string;
    ShippingPhoneNumberFormat: string;
    dropShipDeliveryOptionDisabled = false;
    hidePudoPickupLocationsButton: boolean = true;
    formPickupPersonAddressValid: boolean;
    zipPattern: string | RegExp;
    accountRestriction: boolean = false;
    memberDetails: any;
    accountRestrictionPermission: any[] = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
    accountViewPermission: boolean = false;
    accountRestrictedDisable: boolean = false;
    webOrderId: any;
    originalOrderDetail: any;
    originalCountryCode: any;
    originalOrderCountry: any;
    inActiveRecords = [];
    shippingAddress: Address;
    refSponsorId: number;
    cloneOrderShipMethodId: number;
    pickupShipppingMethodName: any;
    verifyAddressButtonClicked: boolean;
    pudoSuggestedAddressSubscription: Subscription;
    deliveryOptionPurchaseFlow: string;
    memberSearchValidation = false;
    showDropShipPersonAddressForm = false;
    displayDropAddress: boolean;
    dropShipAddress: any | {};
    dropShipOptionAvailable = false;
    dropshipPudoShippingMethod: ShippingMethod = null;
    isPickUpOptionExist = false;
    isDropShipOptionExist = false;
    scandinavianCountry: boolean = false;
    showDistance: boolean = false;
    constructor(private _orderService: OrderService,
        private _sanitizer: DomSanitizer,
        private _formbuilder: FormBuilder,
        private _http: Http,
        private _commonService: CommonService,
        private _translatePipe: TranslateService,
        private _translateKey: TranslateKey,
        private _documentService: DocumentService,
        private _currencyPipe: CurrencyTransformPipe,
        private _cacheService: CacheService,
        private _customerService: CustomerService,
        private messageService: MessageService,
        private _titleCase: TitleCasePipe,
        private _enrollmentMessageService: EnrollmentMessageService,
        private _shippingAddressInfoConfigService: ShippingAddressInfoConfigService,
        private _sponsorConfigService: SponsorConfigService,
        private _checkoutConfigService: CheckoutConfigService,
        private _memberDisplayPriceConfigService: MemberDisplayPriceConfigService,
        private chRef: ChangeDetectorRef,
        private _appConfigService: AppConfigService,
        private _maskPipe: MaskPipe,
        private _groupByPipe: GroupByPipe,
        private _personalInfoConfigService: PersonalInfoConfigService,
        private _orderservice: OrderService,
        private _addressService: AddressService
    ) {
    }
    ngOnInit(): void {
        this.refSponsorId = null;
        this.shippingAddress = null;
        this.dropShipDeliveryOptionDisabled = false;
        this.showDropShipPersonAddressForm = false;
        this.dropShipOptionAvailable = false;
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.orderSession = sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
        this.showDistance = environment.restrictGoogleMapNavigation;
        this.getAllPermissions();
        this.buildForm();
        this.getCountries();
        this.getStates();
        this.getOperatingCountries();
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.createOrderInfo = this._cacheService.get(CacheKey.CREATE_SERVICE_ORDER_INFO_SESSION_CODE);
        this._cacheService.remove(CacheKey.CREATE_SERVICE_ORDER_INFO_SESSION_CODE);
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
        if (this.createOrderInfo) {
            this.orderFromLookup = true;
            this.fboid = this.createOrderInfo.distributorId;
            this.webOrderId = this.createOrderInfo.webOrderId;
            this.originalCountryCode = this.createOrderInfo.countryId;
            this.shoppingBagClicked = this.createOrderInfo.shoppingBagClicked;
        }
        if (this.orderSession) {
            this.shoppingBagClicked = this.orderSession && this.orderSession.shoppingBagClicked ? true : false;
            this.memberCartSessionGuid = this.orderSession.memberCartSessionGuid;
            this.minMaxPriceValidation = this.orderSession.minMaxPriceValidation;
            this.businessEntityId = this.orderSession.businessEntityId;
        }
        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.deleteModal = new DeleteModal(this.clearData.bind(this),
            this.closeDeleteMessage.bind(this), this.closeDeleteMessage.bind(this));
        this.deleteModal.viewActionButtons = true;

        this.orderFromLookup || this.isOrderSessionInfo || this.hasPersistedMemberId
            ? (document.getElementById('country') ? document.getElementById('country').focus() : null)
            : (document.getElementById('memberInfo') ? document.getElementById('memberInfo').focus() : null);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.subscribeSaveAddress();
        this.setPUDOSuggestedAddress();
        this.orderFormGroup.valueChanges.subscribe(formData => {
            if (formData.memberInfo && formData.memberInfo.length !== 0) {
                this.onChanges(formData.memberInfo);
            }

        });
    }

    clearData(): void {

    }

    getFormControls() {
        const items: any = this.orderFormGroup.get('items');
        return items.controls;
    }

    closeDeleteMessage(): void {

    }

    /**
     * @description This method used to get all permissions
     * getAllPermissions()
     * @memberof ServiceOrderComponent
    */
    getAllPermissions(): void {
        this.serviceOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + this.serviceOrderTypePermissions + ']'), AccessLevel.Customer_Service);
    }

    //#region #Start Order Type Section

    orderTypeChange(orderType: OrderType) {
        this.orderTypePrevValue = orderType;
        this.updateCartProduct = 0;
        this.orderFormGroup.controls['orderType'].setValue(orderType);
        if (!this.isOrderSessionInfo) {
            this.address = null;
            this.showSelectedShipMethod = false;
            this.showShippingData = false;
            this.paymentComponentSettings.savedCards = [];
        }
        if (!this.isOrderSessionInfo) {
            this.hasPersistedMemberId ? this.clearAllTheForms(true, true) : this.clearAllTheForms(true, true, true);

        } else {
            this.clearAllTheForms();
        }
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    }

    //#region #Start Build Forms Section

    /**
     * build Form
     */
    buildForm() {
        this.orderFormGroup = this._formbuilder.group({
            orderType: [OrderType.SERVICE_ORDER],
            memberInfo: [this.hasPersistedMemberId && this.fboid ? this.fboid : '', [Validators.required, Utils.noEmptyString, Utils.searchByMemberValidation]],
            items: this._formbuilder.array(this.items),
            countryId: ['', [Validators.required]],
            deliveryPreference: [DeliveryPreference.DELIVERY],
            shippingAddressId: [''],
            shipMethodId: ['', [Validators.required]],
            originalShippingCost: [0, [Validators.required]],
            shippingCost: [''],
            shippingCostPercentage: [''],
            itemSearch: [''],
            itemLevelSearch: [''],
            shippingCostSelector: [this.selectEnum.firstOption.toString()],
            paymentInstrumentId: [''],
            paymentSelector: [],
            backDateOrder: [false],
            saveForFutureUse: [false],
            language: [],
            isContactSponsor: [null],
            isShippingDiscountApplied: [false],
            originalShippingTax: [0, [Validators.required]]
            // paymentMethodForm: this._formbuilder.array([this.createNewPaymentForm()])
        });
        this.orderTypeChange(this.orderFormGroup.controls['orderType'].value);
        this.buildPudoLocationSearchForm();
    }



    /**
     * set Distributor Info from FboId
     */
    getDistributorInfo() {
        this.orderFormGroup.controls['memberInfo'].setValue(this.fboid);
        this.searchMember();
    }
    onKeydown(event: any) {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    }
    /**
     * create item number
     * @returns FormGroup
     */
    createItemNumberGroup(): FormGroup {
        return this._formbuilder.group({
            itemNumber: [''],
            quantity: [''],
            productId: [''],
            productItem: [{}],
            productNumber: [''],
            productName: [''],
            productImage: [[]],
            disableIncrement: [false],
        });
    }
    /**
    * ShippingAddressForm Intialize
    */
    createNewShippingAddress(): FormGroup {
        return this._formbuilder.group({
            name: [''],
            addressLine1: [''],
            addressLine2: [''],
            addressLine3: [''],
            addressLine4: [''],
            city: [''],
            stateId: [''],
            countryId: [''],
            postalCode: [''],
            phone: ['']
        });
    }
    getZipCodePatterns() {
        this._commonService.getZipCodePatterns().subscribe((response: any) => {
            let zipCodePatterns = response;
            if( this.selectedIsoCountryCode){
                const pattern = zipCodePatterns.filter(x => x.isoCodeThree
                    === this.selectedIsoCountryCode.toUpperCase())[0];
                this.zipPattern = pattern ? pattern.zipPattern : null;
            }
        });

        return Validators.pattern(new RegExp(this.zipPattern));
    }

    buildPudoLocationSearchForm(zipCode: string = '', city: string = '', addressLine1: string = '', country: string = '', externalId: string = '') {
        this.pudoLocationSearchForm = this._formbuilder.group({
            zipCode: [zipCode, [Validators.required, this.getZipCodePatterns()]],
            externalId: [externalId],
            city: [city, [Validators.required]],
            country: [country],
            addressLine1: [addressLine1]
        })
        const countryCode = this.selectedIsoCountryCode || '';
        this.pudoLocationSearchForm.patchValue({
            country: countryCode.toUpperCase()
        });
    }

    //#region #Start Countries/ Store and States Section
    /**
    * get Countries
    */
    getCountries() {
        this._customerService.getCountriesLookup(true).subscribe(response => {
            if (response) {
                this.countries = response;
                this._cacheService.set(CacheKey.COUNTRIES, this.countries);
                this.stores = this.countries.filter(country => country.titanPlatformEnabled && country.enrollmentEnabled && country.shopEnabled);
                if (this.originalCountryCode) {
                    this.originalOrderCountry = this.getCountryDetailsByCountryIdOrCode(null, this.originalCountryCode);
                }
                if ((this.orderFromLookup || this.hasPersistedMemberId) && this.fboid) {
                    this.getDistributorInfo();
                } else if (this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['memberInfo'].setValue(this.orderSession.memberInfo);
                    this.searchMember();
                    this.orderFormGroup.controls['orderType'].setValue(this.orderSession.orderType);
                    this.orderTypeChange(this.orderFormGroup.controls['orderType'].value);
                }
                this.orderFromLookup = this.isOrderSessionInfo ? this.orderSession.orderFromLookup : this.orderFromLookup;

            }
        });
    }

    /**
     * To Get all operating countries from configuration service
     */
    getOperatingCountries(): void {
        this._customerService.getAllOperatingCountries().subscribe(response => {
            if (response && response.length > 0) {
                this.operatingCountries = response;
            } else {
                this.operatingCountries = [];
            }
        }, error => {
            this.operatingCountries = [];
        });
    }

    /**
     * get States
     */
    getStates() {
        this._customerService.getStates().subscribe(response => {
            if (response) {
                this.states = response;
            }
        });
    }

    /**
     * Get Country Info by Code or Id
     * @param countryId
     * @param countryCode
     */
    private getCountryDetailsByCountryIdOrCode(countryId: number, countryCode: string): any {
        let countryObj = {};
        if (countryId) {
            countryObj = this.countries.filter((x: any) => x.countryId === countryId)[0];
        }
        if (countryCode) {
            countryObj = this.countries.filter((x: any) => x.isocodeThree === countryCode)[0];
        }
        return countryObj;
    }

    /**
     * Get State Info by Code or Id
     * @param stateId
     * @param stateCode
     */
    private getStateDetailsByStateIdOrCode(stateId: number, stateCode: string, countryCode?: string): any {
        let stateObj = {};
        if (stateId) {
            stateObj = this.states.filter((x: any) => x.id === stateId)[0];
        }
        if (stateCode && countryCode){
            stateObj = this.states.filter((x: any) => x.stateCode === stateCode && x.countryCode === countryCode)[0];
        } else if (stateCode) {
            stateObj = this.states.filter((x: any) => x.stateCode === stateCode)[0];
        }
        return stateObj;
    }

    /**
     * Checks Whether Order Can be BackDated or Not
     * @param timeZoneOffset
     */
    isBackDateOrderAvailable = (timeZoneOffset: number) => {
        this._orderService.isBackDateOrderAllowed(timeZoneOffset, this.countryCode).subscribe(response => {
            if (response && response.success) {
                this.enableBackDateOrder = true;
            } else {
                this.enableBackDateOrder = false;
            }
        });
    }

    /**
     * On Country Select
     */
    selectedCountry() {

        this.isWhosaleCheckNotCalculated = false;
        this.showAddressForm = false;
        this.displayMailingAddressForm = false;
        this.isMemberHasAccessToOrder = true;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
        const selectedCountryID = this.orderFormGroup && this.orderFormGroup.value ? this.orderFormGroup.value.countryId : null;
        if (selectedCountryID) {
            const countryObj = this.countries.filter((x: Country) => x.countryId === +selectedCountryID)[0];
            if (this.memberInfo) {
                this.memberInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.memberInfo);
            }
            this.orderFormGroup.controls['countryId'].disable();
            if (countryObj) {
                this.selectedIsoCountryCode = countryObj.isocodeThree;
                this.checkoutConfig = this._checkoutConfigService.getSettings(countryObj.isocodeThree, this.memberInfo);
                if(this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState){
                    this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                    this._cacheService.set(CacheKey.COUNTRY_ID,countryObj.countryId);
                    this.getCitiesByStates();
                }else{
                    this._cacheService.remove(CacheKey.COUNTRY_CODE);
                    this._cacheService.remove(CacheKey.COUNTRY_ID);
                }
                if (this.memberInfo && this.memberInfo.memberId && this.checkoutConfig && this.checkoutConfig.displayBusinessEntity) {
                    this.loadMemberBasicInfo(this.memberInfo.memberId);
                }
                this.countryCode = countryObj.isocodeThree;
                this.showShippingData = true;
                this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                this.selectedCountryCodeTwo = countryObj.isocodeTwo;
                this.paymentComponentSettings.isoCountryCode = countryObj.isocodeThree;
                this.paymentComponentSettings.isoTwoletterCountryCode = countryObj.isocodeTwo;
                this.storeInfo = null;
                this.sponsorConfig = this._sponsorConfigService.getSettings(countryObj.isocodeThree);
                this.storeId = 0;
                this._enrollmentMessageService.setStoreInfo(this.storeInfo);
                this.getStoreInfo(countryObj.isocodeThree);

                this.skipAddressVerification = this.checkoutConfig.skipAddressVerification;
                if (this.checkoutConfig && this.checkoutConfig.loadParticipatingCountries) {
                    this.getParticipatingCountries(countryObj.isocodeThree);
                }
                if (this.checkoutConfig && !this.checkoutConfig.loadParticipatingCountries) {
                    this.getMemberAddressByMemberId(this.memberInfo.memberId, selectedCountryID);
                }
                this.clearAllTheForms(false);
                this.address = null;
                this.pudoAddress = null;
            }
        }
    }

    /**
    * @description This method used to get cart items by member
    * getCartItemsByMemberAndCartTypeId()
    * @returns void
    */
    getCartItemsByMemberAndCartTypeId(storeInfo: StoreConfig, isSaveBagClicked?: boolean): void {
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId,
            CartTypes.OrderCart, storeInfo)
            .subscribe((cartInfo: Cart) => {
                if (cartInfo && cartInfo.sessionGuid) {
                    this.memberCart = cartInfo;
                    if (!this.isOrderSessionInfo && cartInfo.items && cartInfo.items.length && !isSaveBagClicked) {
                        const productIds = cartInfo.items.map(x => x.productId);
                        this.getProductsByIds(productIds, storeInfo);
                    }
                } else {
                    this.memberCart = null;
                }
            }, error => {
                new Error(error);
            });
    }

    getCitiesByStates() {
        const countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
        this._addressService.getCitiesList(countryId).subscribe((response: any) => {
          console.log(response);
          
          if (response) {
            this.cityList = response;
            this._cacheService.set(CacheKey.Cities, response)
          }
        }
        );
      }

    /**
     * get products by Ids
     */
    getProductsByIds(productsIds: Array<number>, storeInfo: StoreConfig) {
        let fpc5PercentEnabled: boolean = false;
        const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        let memberTitleId = this.memberInfo && this.memberInfo.memberLevelId
            ? this.memberInfo.memberLevelId : this.memberInfo.memberTitleId;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        const purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
        // HARD_DOWNGRADE CHECK FOR FPC USERS
        memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        this._orderService.getProductsByIds(productsIds, this.storeDefaultLanguage, storeInfo.id,
            memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, storeInfo.taxInclusive).subscribe(response => {
                if (response && response.length > 0) {
                    if (this.originalOrderDetail && this.originalOrderDetail.orderLineItems) {
                        const orderLineItems = this.originalOrderDetail.orderLineItems.map(x => x.productId);
                        const responseProductId = response.map(x => x.id);
                        const inactiveProducts = orderLineItems.filter(item => responseProductId.indexOf(item) < 0);
                        if (inactiveProducts) {
                            this.inActiveRecords = [];
                            inactiveProducts.forEach(inactive => {
                                this.originalOrderDetail.orderLineItems.forEach(element => {
                                    if (element.productId == inactive) {
                                        this.inActiveRecords.push(element.productName);
                                    }
                                });
                            });
                        }
                    }
                    this.loadproducts(response);
                } else {
                    if (this.originalOrderDetail && this.originalOrderDetail.orderLineItems) {
                        this.inActiveRecords = [];
                        this.originalOrderDetail.orderLineItems.forEach(element => {
                            this.inActiveRecords.push(element.productName)
                        });
                    }
                }
                if (this.inActiveRecords && this.inActiveRecords.length >= 1) {
                    this.showInvalidConfigurationError();
                }
            });
    }
    showInvalidConfigurationError(): void {
        const invalidConfigurationError: any = this._translatePipe.get('order.Product(s) are Inactive or Invalid Configuration ');
        const configError = '<b class="helvetica-bold">' + this.inActiveRecords.toString() + '</b> &nbsp;' + invalidConfigurationError.value;
        this._commonService.createNotification('', configError, NotificationType.ERROR);
    }
    /**
     *load procducts from session
     */
    loadproducts(products: Product[]) {
        products.forEach((product: Product) => {
            const isDepositFeeProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1');
            if (!isDepositFeeProduct) {
                this.addItemNumber();
                const items: any = this.orderFormGroup.get('items');
                if (items && items.length > 0) {
                    const index = (items.length - 1);
                    if (product) {
                        const itemValue = product.itemNumber + ' - ' + product.name;
                        items.controls[index].controls['itemNumber'].setValue(itemValue);
                        const itemImage = (product.imageModelList && product.imageModelList.length > 0)
                            ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
                        const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                            : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                        items.controls[index].controls['productImage'].setValue(imageUrl);
                        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                        items.controls[index].controls['productId'].setValue(product.id);
                        items.controls[index].controls['productItem'].setValue(product);
                        items.controls[index].controls['disableIncrement'].setValue(false);
                        items.controls[index].controls['quantity'].setValidators([Validators.required]);
                        items.controls[index].controls['quantity'].updateValueAndValidity();
                        if (this.isOrderSessionInfo) {
                            const productInfo = this.orderSession.products.find((item: any) => product.id === item.productId);
                            items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                        } else if (this.originalOrderDetail) {
                            const productInfo = this.originalOrderDetail.orderLineItems.find((item: any) => product.id === item.productId);
                            items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                        }
                        else if (this.orderFormGroup && !this.isOrderSessionInfo) {
                            let productInfo = null;
                            if (this.memberCart && this.memberCart.items.length > 0) {
                                productInfo = this.memberCart.items.find((item: any) => product.id === item.productId);
                            }
                            items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                        }
                    }
                }
            }
        });
        this.updateTotalsAndShipMethod();
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && !this.isOrderSessionInfo) {
            this.getShipMethods();
        }
    }

    /**
    * removing not available cart items based on logged in user
    * @param  {Cart} orderCart
    * @param  {CartItem[]} unAvailableCartItems
    */
    private deleteCart(sessionGuid: string) {
        if (sessionGuid) {
            this.shoppingCartCount = 0;
            this.itemCount = 0;
            this._customerService.removeCartItem(sessionGuid,
                this.storeInfo.id).subscribe(response => {
                });
        }
    }

    /**
     * @description constructing the schema form url
     * @memberof ServiceOrderComponent
     */
    constructSchemaFormUrl(countryCode: string): void {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        this.billingSchemaUrl = countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
            + environment.templateVersion;
        this.mailingSchemaUrl = countryCode.toLowerCase() + '-mailing-schema-form.json?templateVersion='
            + environment.templateVersion;
        setTimeout(() => {
            this.address = this.address;
            this.mailingAddress = this.mailingAddress;
            this.displayMailingAddressForm = true;
            this.showAddressForm = true;
            this.shippingDeliveryOptionAvailable = true;
        }, 500);
        this.orderFormGroup.controls['countryId'].enable();
    }
    // get existing shopping cart item count
    getShoppingCartCount(storeInfo: StoreConfig): void {
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId,
            CartTypes.OrderCart, storeInfo)
            .subscribe((cartInfo: Cart) => {
                this.existingItemCount = 0;
                if (cartInfo && cartInfo.sessionGuid) {
                    this.memberCartInfo = cartInfo;
                    this.existingItemCount = 0;
                    let cartItems = cartInfo.items;
                    for (let index = 0; cartItems.length > 0 && cartItems.length > index; index++) {
                        this.existingItemCount += cartItems[index].quantity;
                    }
                    this.shoppingCartCount = this.existingItemCount;
                } else {
                    this.existingItemCount = 0;
                }
            }, error => {
                new Error(error);
            });
    }

    /**
     * Get Store Info
     * @param countryCode
     */
    getStoreInfo(countryCode: any) {
        if (countryCode) {
            this._orderService.getStoreInfo(countryCode).subscribe(response => {
                if (response) {
                    this.storeInfo = response;
                    const storeInfo = response;
                    if (!this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
                        this.getShoppingCartCount(storeInfo);
                    }
                    this.distributorMaxCC = storeInfo.distributorMaxCC;
                    if (this.memberInfo && this.memberInfo.fboId && this.memberInfo.memberAllowedCountries
                        && this.memberInfo.memberAllowedCountries.length > 0
                        && (+this.memberInfo.memberTypeId === MemberTypeEnum.FPC || +this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
                        if (countryCode) {
                            this.getWholsesaleQualifiedDetails(this.memberInfo.fboId, countryCode, storeInfo);
                        } else {
                            this.getMemberDiscountPercentages(storeInfo);
                        }
                    } else {
                        this.getMemberDiscountPercentages(storeInfo);
                    }
                    this.storeId = response.id;
                    this.countryCode = countryCode;
                    this.countryTaxInclusive = storeInfo.taxInclusive;
                    this.shippingAddressInfoConfig = this._shippingAddressInfoConfigService.getSettings(countryCode);
                    this.appConfig = this._appConfigService.getSettings(countryCode, this.memberInfo); //storeConfiguration
                    this.getOrderRules(storeInfo);
                    if (response.languages && response.languages.length > 0) {
                        this.storeDefaultLanguage = response.languages.find((languageCulture: any) => languageCulture.default).cultureName;
                        this.languageShortCode = response.languages.find((languageCulture: any) => languageCulture.default).languageCode;
                    } else {
                        this.storeDefaultLanguage = this.languageCode;
                    }
                    this.getOrderDetails(storeInfo);
                    let memberType: string;
                    if (+this.memberInfo.memberTypeId === MemberTypeEnum.GUEST) {
                        memberType = MemberType.GUEST;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                        if (this.isOrderSessionInfo) {
                            this.sponsorInformation = this.orderSession.sponsorInformation;
                        }
                    } else if (+this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
                        memberType = MemberType.Distributor;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    } else if (+this.memberInfo.memberTypeId === MemberTypeEnum.FPC) {
                        memberType = MemberType.PREFERRED_CUSTOMER;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    } else if (+this.memberInfo.memberTypeId === MemberTypeEnum.RETAIL) {
                        memberType = MemberType.RETAIL;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                    }
                    //this.isBackDateOrderAvailable(response.timeZoneOffset);
                    const getDeliveryOptionsRequest: any = {
                        memberTypeId: this.memberInfo ? this.memberInfo.memberTypeId : MemberTypeEnum.RETAIL,
                        memberType: memberType.toUpperCase(),
                        source: Source.SERVICE,
                        countryCode: countryCode,
                        purchaseFlow: this.deliveryOptionPurchaseFlow,
                        storeId: this.storeId
                    };
                    this.shippingDeliveryOptionAvailable = false;
                    this.pickupDeliveryOptionAvailable = false;
                    this._orderService.getDeliveryOptions(countryCode, getDeliveryOptionsRequest).subscribe(res => {
                        if (res) {
                            this.dropShipDeliveryOptionDisabled = false;
                            res.forEach(option => {
                                if (option.optionValue === DelivaryOptionType.Delivery) {
                                    this.shippingDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Pickup) {
                                    this.pickupDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Dropship) {
                                    if (option.optionDisabled) {
                                        this.dropShipDeliveryOptionDisabled = true;
                                    } else if (this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                        this.dropShipOptionAvailable = true;
                                    } else {
                                        this.pickupDeliveryOptionAvailable = true;
                                    }
                                }


                            });
                            const isDropShip = res.find((x)=> x.optionValue == DelivaryOptionType.Dropship);
                            const isPickUp = res.find((x)=> x.optionValue == DelivaryOptionType.Pickup);
                            if (environment.scandinavianCountries && this.countryCode) {
                                let scandinavianCountries = environment.scandinavianCountries;
                                this.scandinavianCountry = scandinavianCountries.split(",").find(country => country === this.countryCode);
                            }
                            // For Scandian country checking for Pickup
                            if (this.scandinavianCountry && isPickUp) {
                                this.isPickUpOptionExist = true;
                            }
                            // For Non-Scandian country checking for DropShip
                            if (!this.scandinavianCountry && isDropShip && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && !this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                this.isDropShipOptionExist = true;
                            }
                            // For Non-Scandian country checking for PickUp
                            if (!this.scandinavianCountry && isPickUp && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                this.isPickUpOptionExist = true;
                            }
                            if (!this.scandinavianCountry && isPickUp && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                this.isPickUpOptionExist = true;
                            }
                            this.storeInfo = storeInfo;
                            if (this.memberInfo) {
                                this.memberInfo = { ...this.memberInfo, displayMiddleName: this.storeInfo.displayMiddleName };
                            }
                            this.storeInfo.ccNumberDecimals = 3;
                            this.storeInfo.ccNumberFormat = 'CR';
                            this.storeInfo.ccSymbol = 'CC';

                            this.paymentComponentSettings.languageCode = this.languageCode;
                            this.paymentComponentSettings.storeId = this.storeInfo.id;
                            this.paymentComponentSettings.currencyCode = this.storeInfo.currencyCode;
                            this.paymentComponentSettings.numberDecimals = this.storeInfo.numberDecimals;
                            this.countryCode = countryCode;
                            this.memberId = this.memberInfo ? this.memberInfo.memberId : null;
                            if (this.isOrderSessionInfo) {
                                this.updateTotalsAndShipMethod();
                            }

                        }
                    });
                    this.getPaymentMethodsByStore();
                }
            }, error => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Store Details');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
    }

    /**
     * @description
     * @memberof ServiceOrderComponent
     */
    getMemberRankLevelHistory(orderRulesRequest, storeInfo: StoreConfig, userInfo: Member, isFboUpgradeFlow: boolean): void {
        if (!isFboUpgradeFlow) {
            return;
        }
        this.isFBOValidationPending = true;
        if (this.memberInfo && this.memberInfo.memberId && storeInfo && storeInfo.countryId) {
            this._commonService.getMemberRankLevelHistory(this.memberInfo.memberId, storeInfo.countryId)
                .subscribe(response => {
                    if (response) {
                        this.memberLevelHistory = response;
                        const memberLevelInfo = this.memberLevelHistory
                            .find((memberLevel: MemberLevelHistory) => memberLevel.memberTitleId === MemberTitleExtEnums.PreferredCustomer);
                        const isMemberFboUpgraded = memberLevelInfo ? true : false;
                        const dateParts =  this.memberInfo.enrolmentDate ? this.memberInfo.enrolmentDate.split('-') : this.memberInfo.createdDate.split('-');
                        const enrollmentWindowDate = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
                        enrollmentWindowDate.setHours(0, 0, 0, 0);
                        enrollmentWindowDate.setDate(enrollmentWindowDate.getDate() + this.restrictedDays);
                        const currentDate = new Date();
                        currentDate.setHours(0, 0, 0, 0);
                        this.isFBOValidationPending = false;
                        if (isMemberFboUpgraded && (enrollmentWindowDate.getTime() > currentDate.getTime())) {
                            orderRulesRequest.optinFbo = true;
                            this.isMemberFboUpgraded = true;
                            this.getBusinessOrderRules(orderRulesRequest, userInfo, true);
                        } else {
                            this.isMemberFboUpgraded = false;
                            this.getBusinessOrderRules(orderRulesRequest);
                            this.getMemberOrderRules(userInfo, false);
                        }
                    } else {
                        this.memberLevelHistory = [];
                        this.isMemberFboUpgraded = false;
                        this.isFBOValidationPending = false;
                        this.getMemberOrderRules(userInfo, false);
                        this.getBusinessOrderRules(orderRulesRequest);
                    }
                });
        }
    }

    /**
     * @description
     * @private
     * @memberof ServiceOrderComponent
     */
    private loadMemberShoppingCart(storeInfo: StoreConfig): void {
        // get Member cart items when shopping bag clicked
        if (this.orderFormGroup.value.orderType === this.orderType.REGULAR && !this.memberCartSessionGuid
            && this.shoppingBagClicked && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId(storeInfo);
        }
        else if (!this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.memberCart = null;
        } else {
            this.memberCart = null;
        }
    }

    /**
     * @description
     * @private
     * @memberof ServiceOrderComponent
     */
    private getMemberDiscountPercentages(storeInfo: StoreConfig): void {
        this.loadMemberShoppingCart(storeInfo);
        const optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        const wholeSaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false;
        const memberTitleID = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        if (this.memberInfo) {
            this.memberInfo.transactionalWholesaleQualified = wholeSaleQualified;
            this.memberInfo.transactionalOptin = optin;
        }
        if (this.taxCalculationStatus) {
            this.updateTotalsAndShipMethod();
        }
        this._commonService.getDiscountPercentages(wholeSaleQualified, optin, memberTitleID, storeInfo.id).
            subscribe(response => {
                this.memberDiscountPercentage = response;
            });
    }

    //#endregion

    onChanges(memberInfo: any) {
        const emailPattern = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
        let numberPattern = /^[0-9]+$/;
        const distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        if ((new RegExp(distributorIdPattern).test(memberInfo)) || new RegExp(numberPattern).test(memberInfo)) {
            this.memberSearchValidation = false;
            return;
        }
        else if (new RegExp(emailPattern).test(memberInfo) && !new RegExp(numberPattern).test(memberInfo)) {
            this.memberSearchValidation = false;
            return;
        }
        else {
            this.memberSearchValidation = true;
        }
    }

    searchMember() {
        if (!this.orderFromLookup) {
            this.webOrderId = '';
        }
        this.searchReqValues = this.orderFormGroup.getRawValue();
        let fboId = this.searchReqValues.memberInfo;
        const distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        const emailPattern = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
        if (new RegExp(distributorIdPattern).test(this.searchReqValues.memberInfo)) {
            fboId = fboId.replace(/-|\s/g, '');
        }
        let type = '';
        type = this.searchReqValues.memberInfo.indexOf('@') > -1 ? 'email' : 'fboId';
        if (this.memberSearchValidation || this.searchReqValues.memberInfo.length === 0) {
            return;
        }
        this._orderService.getMemberInfo(fboId, type).subscribe(response => {
            if (response && response.memberId) {
                this.memberInfo = response;
                if (response.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
                    this.getMembergovernmentIdentificationsInfo(response.memberId);
                }
                this.memberStatus = response.memberStatus;
                if (this.memberStatus && this.memberStatus.id) {
                    this.isActive = (this.memberStatus.id === +MemberStatus.Active);
                } else {
                    this.isActive = false;
                }
                fboId = type == 'email' ? response.fboId : fboId;
                this._commonService.getMemberStatus(fboId).subscribe(response => {
                    if (response && response.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission) {
                        this.accountRestriction = true;
                        const memberlevel = this._commonService.getMemberLevel(this.memberInfo.memberLevelID);
                        const memberDetails = {
                            fboId: fboId,
                            firstName: this.memberInfo.firstName,
                            lastName: this.memberInfo.lastName,
                            memberLevel: memberlevel
                        };
                        this.memberDetails = memberDetails;
                        this.orderFormGroup.controls['countryId'].setValue('');
                        this.accountRestrictedDisable = true;
                    } else {
                        this.accountRestrictedDisable = false;
                        this.searchMemberInfo(fboId);
                    }
                });
            } else {
                this.clearAllTheForms(true, true);
                const notification: any = this._translatePipe.get('order.Member Details Not Found');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, error => {
            const notification: any = this._translatePipe.get('order.Unable to retrieve Member Details');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    }

    closeModal(status: boolean) {
        this.accountRestriction = status;
    }

    // region #Start Member Function Section
    /**
     * On Member Details Search
     */
    searchMemberInfo(fboId: any) {
        this.isWhosaleCheckNotCalculated = false;
        this.isMemberHasAccessToOrder = true;
        this.memberSearchSubmitted = true;
        this.memberInfo = null;
        if (this.orderFormGroup.value.memberInfo && this.orderFormGroup.value.memberInfo.length > 0) {
            this.getMemberInfo(fboId);
        }
    }

    /**
     * Get Member Info by EmailID or FBOID
     */
    getMemberInfo(memberDetails: string) {
        let type = '';
        type = memberDetails.indexOf('@') > -1 ? 'email' : 'fboId';

        this._orderService.getMemberInfo(memberDetails, type).subscribe(response => {
            if (response && response.memberId) {
                this.serviceOrderMemberDetails.emit(memberDetails);
                this.messageService.setPersitedMemberId(memberDetails);
                this.orderFromLookupEmit.emit(this.orderFromLookup);
                this.storeInfo = null;
                if (response.memberTitleId && response.memberTypeId && (response.memberTitleId === MemberTitleExtEnums.Novus_Customer
                    && +response.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
                    response.memberTitleId = MemberTitleExtEnums.PreferredCustomer;
                }
                // Add Validation for Member Level
                this.getMemberLevelInfo(response);
            } else {
                this.clearAllTheForms(true, true);
                const notification: any = this._translatePipe.get('order.Member Details Not Found');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, error => {
            const notification: any = this._translatePipe.get('order.Unable to retrieve Member Details');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    }

    getMemberLevelInfo(memberResponse): void {
        this.processMemberResponse(memberResponse);
        this.accountMemberInfo = Object.assign({}, memberResponse);
    }

    processMemberResponse(response): void {
        const notification: any = this._translatePipe.get('order.Member Details Found');
        this.memberInfo = response;
        if (response && response.sponsorId) {
            this.refSponsorId = response.sponsorId;
        }
        this.memberInfo.enrolmentDate = this.memberInfo.lastUpgradedDate;
        if (this.memberInfo && (+this.memberInfo.memberTypeId === MemberTypeEnum.GUEST)) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        } else if (+response.memberTypeId === MemberTypeEnum.FPC || this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        else if (this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR && this.memberInfo.memberTitleId === MemberLevel.NOVICCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if (+response.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        if (response.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
            this.getMembergovernmentIdentificationsInfo(response.memberId);
        }
        this.orderTaxResponse = null;
        this.memberStatus = response.memberStatus;
        if (this.memberStatus && this.memberStatus.id) {
            this.isActive = (this.memberStatus.id === +MemberStatus.Active);
        } else {
            this.isActive = false;
        }
        if (+response.memberTypeId === MemberTypeEnum.GUEST) {
            this.memberInfo.memberLevel = MemberType.GUEST;
        }
        this.memberSearchSubmitted = false;
        this.memberTypeId = this.memberInfo.memberTypeId;
        this.clearAllTheForms();
        setTimeout(() => {
            this.getAgentAllowedCountries();
        }, 2000);

        this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
        if (this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            const country = this.countries.filter(x => x.countryId === this.memberInfo.address.countryId)[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        this.paymentComponentSettings.memberId = this.memberInfo.memberId;
        this.paymentComponentSettings.memberTypeId = this.memberInfo.memberTypeId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        const memberTitleID = this._orderService.getMemberTitleId(this.memberInfo);
        this.personalDiscountPercentage = this._commonService.getPersonalDiscount(memberTitleID);
    }

    /**
     * Get wholesale qualified details for a FPC / FBO based on memberID and countryCode
     * @param memberID
     * @param countryCode
     */

    private getWholsesaleQualifiedDetails(fboId: string, memberHomeCountry: string, storeInfo: StoreConfig) {
        this._commonService.getWholsesaleQualifiedDetails(fboId, memberHomeCountry)
            .subscribe((res: WholesaleQualifiedResponse) => {
                try {
                    if (res) {
                        this.isWhosaleCheckNotCalculated = false;
                        if (res && res.error) {
                            this.wholesaleCheckErrorNotifications();
                        }
                        this.memberInfo.optin = res.optIn ? res.optIn : false;
                        this.memberInfo.wholeSaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                        // Member wholesale qualified eligibility check
                        this.memberInfo.transactionalWholesaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                        this.memberInfo.transactionalOptin = res.optIn ? res.optIn : false;

                        let balance;
                        try {
                            balance = Number(res.balance);
                        } catch {
                            balance = this.distributorMaxCC;
                        }
                        if (!balance) {
                            balance = this.distributorMaxCC;
                        }
                        this.existingCC = balance;
                        this.getMemberDiscountPercentages(storeInfo);
                    }
                } catch (error) {
                    this.getMemberDiscountPercentages(storeInfo);
                    this.wholesaleCheckErrorNotifications();
                }
            }, error => {
                this.getMemberDiscountPercentages(storeInfo);
                this.wholesaleCheckErrorNotifications();
            });
    }

    loadMemberBasicInfo(memberId: number) {
        if (memberId && !this.businessEntityId) {
            this._customerService.getMemberBasicInfoById(memberId)
                .subscribe((res) => {
                    this.memberBasicInfo = res;
                    if (res && res.businessEntities) {
                        const activeBusinessEntity: FBOBusinessEntity = res.businessEntities.find((entity: FBOBusinessEntity) => entity.status === RowStatus.Active && entity.countryCodeId);
                        const country = this.countries && activeBusinessEntity && this.countries.find((country) => country.countryId && country.countryId === activeBusinessEntity.countryCodeId);
                        if (activeBusinessEntity && country.isocodeThree.toLowerCase() === this.countryCode.toLowerCase()) {
                            if (this._orderService.isValidDate(activeBusinessEntity.startDate, activeBusinessEntity.endDate)) {
                                this.businessEntityId = activeBusinessEntity.id;
                            } else {
                                this.businessEntityId = null;
                            }
                        }
                    }
                },
                    (error) => { }
                );
        }
    }

    /**
     * @description to display Error Message If WholesaleCheck  are not calculated
     * @memberof ServiceOrderComponent
     */
    wholesaleCheckErrorNotifications() {
        this.isWhosaleCheckNotCalculated = true;
        let notification: any = this._translatePipe.get('order.The order is not receiving the PC Wholesale response from Valence. Please try again later.');
        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
    }

    /**
    * Member Allowed Countries Filter
    * @param memberAllowedCountries
    */
    private populateCountries(memberAllowedCountries: any) {
        this.memberCountries = [];
        if (memberAllowedCountries && memberAllowedCountries.length > 0 && this.countries && this.countries.length > 0) {
            memberAllowedCountries.forEach((allowedCountry: any) => {
                const countryObj = this.stores
                    .filter((country: any) => country.cspServiceOrderEnabled && allowedCountry.isoCodeThree === country.isocodeThree)[0];
                if (countryObj) {
                    if (!(this.memberCountries.findIndex((country: any) => country.isoCodeThree === countryObj.isocodeThree) >= 0)) {
                        this.memberCountries.push({
                            id: countryObj.countryId, name: countryObj.name, isoCodeThree: countryObj.isocodeThree,
                            isoCodeTwo: countryObj.isocodeTwo, homeCountry: allowedCountry.homeCountry
                        });
                        if (allowedCountry.homeCountry) this.homeCountry = allowedCountry.isoCodeThree;
                    }
                }
            });
            if (!this.userInfo.hasSystemRole) {
                let allowedCountry;
                let allowedCountries = [];
                let allowedOperatingCountries = [];
                if (this.operatingCountries && this.operatingCountries.length > 0 && this.agentAllowedCountries && this.agentAllowedCountries.length > 0) {
                    allowedOperatingCountries = this.operatingCountries.filter(item => {
                        return this.agentAllowedCountries.indexOf(item.operatingCountryCode) > -1;
                    });
                    if (allowedOperatingCountries && allowedOperatingCountries.length > 0 && this.memberCountries && this.memberCountries.length > 0) {
                        allowedOperatingCountries.forEach(operatingCountry => {
                            allowedCountry = this.memberCountries.find(memberCountry => memberCountry.isoCodeThree === operatingCountry.countryCode);
                            if (allowedCountry) {
                                allowedCountries.push(allowedCountry);
                            }
                        });
                        this.memberCountries = JSON.parse(JSON.stringify(allowedCountries));
                    } else {
                        this.memberCountries = [];
                    }
                } else {
                    this.memberCountries = [];
                }
            }
            this.sortTableByColumn('name');
            if (this.isOrderSessionInfo) {
                this.orderFormGroup.controls['countryId'].setValue(this.orderSession.countryId);
                this.selectedCountry();
            } else if (this.createOrderInfo && this.createOrderInfo.countryId && this.shoppingBagClicked) {
                this.orderFormGroup.controls['countryId'].setValue(this.createOrderInfo.countryId);
                this.selectedCountry();
            } else if (this.originalOrderCountry && this.originalOrderCountry.countryId) {
                const selectedCountryDetail = this.memberCountries.find(country => country.id === this.originalOrderCountry.countryId);
                if (selectedCountryDetail) {
                    this.orderFormGroup.controls['countryId'].setValue(this.originalOrderCountry.countryId);
                    this.selectedCountry();
                } else {
                    this.showPermissionErrorMessage(this.originalOrderCountry.name);
                    return;
                }
            } else if (this.memberCountries.length > 0) {
                const countryObj = this.memberCountries.find(country => country.homeCountry === true);
                if (countryObj) {
                    this.orderFormGroup.controls['countryId'].setValue(countryObj.id);
                } else {
                    this.orderFormGroup.controls['countryId'].setValue(this.memberCountries[0].id);
                }
                this.selectedCountry();
            }
        }
    }

    sortTableByColumn(property: any) {
        const direction = 1;
        this.memberCountries.sort(function (a, b) {
            if (a[property] < b[property]) {
                return -1 * direction;
            } else if (a[property] > b[property]) {
                return 1 * direction;
            } else {
                return 0;
            }
        });
    }

    /**
    *
    * @param memberId get Member Addresses
    */
    getMemberAddressByMemberId(memberId: any, countryId: any) {
        this.shippingAddressInfo = null;
        this.billingAddressInfo = null;
        this._orderService.getMemberAddressByMemberId(memberId, countryId).subscribe(response => {
            this.memberAddressDetails = [];
            this.memberShippingDetails = [];
            if (response && response.length > 0) {
                this.memberAddressDetails = response.filter(x => x.addressTypeId === AddressType.SHIPPING);
                this.memberAddressDetails = this._commonService.sortMemberAddress(this.memberAddressDetails);
                this.addressSearchResult = this.memberAddressDetails;
                if (!this.isOrderSessionInfo && (this.orderSession === null || !this.orderSession.shippingAddressId)) {
                    this.address = this.memberAddressDetails.find(x => x.defaultAddress === true);
                    if (this.address) {
                        this.address.phone = this.address.phoneNumber;
                        this.address.email = this.address.email ? this.address.email : null;
                        this.address.isShowStateCode = this.checkoutConfig.showStateCode;
                        this.address.isSavedAddress = true;
                        this.shippingAddressInfo = this.address;
                        this.savedAddressId = this.address.id;
                        this.showShippingData = true;
                        this.constructSchemaFormUrl(this.countryCode);
                    } else {
                        if (this.memberAddressDetails && this.memberAddressDetails.length > 0) {
                            this.address = this.memberAddressDetails[0];
                            this.shippingAddressInfo = this.address;
                        }
                        this.constructSchemaFormUrl(this.countryCode);
                    }
                }
                this.memberShippingDetails = response.filter(x => x.addressTypeId === AddressType.SHIPPING);
                if (this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
                    // check for shpping address when order info is in cache
                    if (this.orderSession.shippingAddressId) {
                        this.address = this.memberShippingDetails.find((x: any) => x.id === this.orderSession.shippingAddressId);
                        this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId, { onlySelf: true });
                        if (this.address) {
                            this.address.phone = this.address.phoneNumber;
                            this.address.email = this.address.email ? this.address.email : null;
                            this.address.isSavedAddress = true;
                            this.shippingAddressInfo = this.address;
                            this.savedAddressId = this.address.id;
                            this.constructSchemaFormUrl(this.countryCode);
                            this.showShippingData = true;
                        } else {
                            this.mapShippingAddressDetailsFromSession();
                        }
                    } else {
                        this.mapShippingAddressDetailsFromSession();
                    }
                    if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                        this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                        this.validationsOnDeliveryPreference();
                    }
                    this.loadproductsFromSession();
                }
            } else {
                if (this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
                    if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                        this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                        this.constructSchemaFormUrl(this.countryCode);
                        this.validationsOnDeliveryPreference();
                    } else {
                        if (this.orderSession.shippingAddressId) {
                            this.address = this.orderSession.shippingAddressInfo;
                            this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId,
                                { onlySelf: true });
                            if (this.address) {
                                this.shippingAddressInfo = this.address;
                                this.savedAddressId = this.address.id;
                                this.constructSchemaFormUrl(this.countryCode);
                                this.address.isSavedAddress = this.orderSession.isSavedAddress;
                                this.showShippingData = true;
                                this.verifiedShippingAddressId = this.orderSession.verifiedShippingAddressId;
                                this.address.id = this.orderSession.shippingAddressId;
                            }
                        } else {
                            this.mapShippingAddressDetailsFromSession();
                        }
                    }
                    // check for shpping address when order info is in cache
                    this.loadproductsFromSession();
                } else {
                    if (this.countryCode === this.homeCountry && this.memberInfo && this.memberInfo.address && this.allowMemberInfoAddress()) {
                        this.address = this.memberInfo.address;
                        this.address.email = this.memberInfo.email ? this.memberInfo.email : null;
                        this.address.firstName = this.memberInfo.firstName;
                        this.address.middleName = this.memberInfo.middleName;
                        this.address.lastName = this.memberInfo.lastName;
                        this.address.stateCode = this.memberInfo.address.stateCode;
                        this.address.countryCode = this.countryCode;
                        if (!this.address.countryId) {
                            this.address.countryId = this.memberCountries.find(country => country.isoCodeThree === this.countryCode).id;
                        }
                        this.address.isShowStateCode = this.checkoutConfig.showStateCode;
                        this.shippingAddressInfo = this.address;
                        this.savedAddressId = this.address.id;
                        this.showShippingData = true;
                    } else if (this.memberInfo) {
                        this.address = {};
                        this.address.email = this.memberInfo.email ? this.memberInfo.email : null;
                        this.address.firstName = this.memberInfo.firstName;
                        this.address.middleName = this.memberInfo.middleName;
                        this.address.lastName = this.memberInfo.lastName;
                        this.address.countryCode = this.countryCode;
                        this.address.countryId = this.memberCountries.find(country => country.isoCodeThree === this.countryCode).id;
                        const notification: any = this._translatePipe.get('order.Address Information for this member is not available to populate');
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                    if (this.memberInfo.memberContacts && this.memberInfo.memberContacts.length > 0) {
                        const memberContact = this.getPhoneNumber(this.memberInfo.memberContacts);
                        if (memberContact) {
                            this.address.phoneType = memberContact.contactTypeID;
                            this.address.phone = memberContact.value ? memberContact.value : null;
                        }
                    }
                    this.constructSchemaFormUrl(this.countryCode);
                }
            }
            if (this.memberAddressDetails && this.memberAddressDetails.length === 0) {
                this.orderFormGroup.controls['shippingAddressId'].setValue('');
            }
        }, error => {
            this.orderFormGroup.controls['countryId'].enable();
            const notification: any = this._translatePipe.get('order.Unable to retrieve Member Addresses');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.constructSchemaFormUrl(this.countryCode);
        });
    }

    allowMemberInfoAddress(): boolean {
        if (this.memberInfo.address.countryId && this.memberCountries) {
            let country = this.memberCountries.find(country => country.isoCodeThree === this.countryCode);
            return country.id === this.memberInfo.address.countryId;
        }
        return true;
    }

    getPhoneNumber(memberContacts): MemberContact {
        const phoneType = this.checkoutConfig.removeMobileField ? ContactTypeValue.PHONE :  this.checkoutConfig.removePhoneField ?  ContactTypeValue.MOBILE :ContactTypeValue.MOBILE;
        let phoneNumber = memberContacts.find(item => (item.contactTypeID == phoneType) && item.value);
        return phoneNumber;
    }

    /**
   * Mapping Shipping address from session
   */
    mapShippingAddressDetailsFromSession() {
        if (this.orderSession && this.orderSession.shippingAddressInfo) {
            this.address = this.orderSession.shippingAddressInfo;
            this.shippingAddressInfo = this.address;
            this.shippingAddressInfo.email = this.address.email ? this.address.email : null;
            this.shippingAddressInfo.phoneNumber = this.address.phoneNumber ? this.address.phoneNumber : this.address.phone ? this.address.phone : null;
            this.savedAddressId = this.address.id;
            this.verifiedShippingAddressId = this.orderSession.verifiedShippingAddressId;
            this.address.isSavedAddress = this.orderSession.isSavedAddress;
            this.showShippingData = true;
        }
        this.constructSchemaFormUrl(this.countryCode);
    }

    // endregion
    /**
    * Delivery Preference On Change
    * @param value delivery preference
    */
    deliveryPreferenceOnChange() {
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.orderTaxResponse = null;
        this.dropShipAddress = null;
        this.shippingAddressChanged = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
        } else {
            this.showPudoPickupPersonAddressForm = false;
            this.displayPudoAddress = false;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
        } else {
            this.showDropShipPersonAddressForm = false;
        }
        this.getShipMethods();
        this.validationsOnDeliveryPreference();
        //this.updateTotalsAndShipMethod();

    }
    /**
     * update validations on delivery preference
     */
    validationsOnDeliveryPreference() {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.shippingAddressInfo = null;
            this.orderFormGroup.controls['shipMethodId'].setValue('');
            this.getShipMethods(true);
        } else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY) {
            this.selectedpickup = undefined;
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
            this.updateTotalsAndShipMethod();
        }
    }

    /**
     * map the billing address fields
     */
    mapBillingAddress() {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
            && (this.shippingAddressInfo && this.shippingAddressInfo.countryId)
            || (this.mailingAddress && this.mailingAddress.countryId)) {
            this.paymentComponentSettings.billingAddress = this.shippingAddressInfo || this.mailingAddress;
            let country: Country;
            const address = this.shippingAddressInfo || this.mailingAddress;
            if (address && (address.stateCode === PaymentConstants.PuertoRico
                || address.stateCode === PaymentConstants.MarshallIslands
                || address.stateCode === PaymentConstants.VirginIslands)) {
                if (address.stateCode === PaymentConstants.MarshallIslands) {
                    country = this.countries.filter(x => x.isocodeThree.toLowerCase()
                        === address.stateCode.toLowerCase())[0];
                } else {
                    country = this.countries.filter(x => x.isocodeTwo.toLowerCase()
                        === address.stateCode.toLowerCase())[0];
                }
            } else {
                country = this.countries.filter(x => x.countryId === address.countryId)[0];
            }
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = address.postalCode;
        } else if (this.memberInfo && this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            const country = this.countries.filter(x => x.countryId === this.memberInfo.address.countryId)[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }

    }

    /**
     * On Shipping Address Selected
     */
    selectedShippingAddress(address: Address) {
        this.addressSearchResult = this.memberAddressDetails;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
            const addressDetailId = address.id;
            address.isSavedAddress = true;
            if (addressDetailId && this.memberShippingDetails) {
                const shippingAddress = this.memberShippingDetails.filter((x: any) => x.id === addressDetailId);
                if (shippingAddress && shippingAddress[0]) {
                    this.pudoShippingAddressInfo = shippingAddress[0].shippingAddress;
                }
            }
            this.savedPudoAddressId = address.id;
            address.isShowStateCode = this.checkoutConfig.showStateCode;
            this.pudoShippingAddressInfo = address;
            this.pudoAddress = address;
            this.pudoAddress.phone = address.phoneNumber;
            this.pudoAddress.email = address.email ? address.email : '';
            this.showPudoPickupPersonAddressForm = true;
        } else {
            const addressDetailId = address.id;
            address.isSavedAddress = true;
            if (addressDetailId && this.memberShippingDetails) {
                const shippingAddress = this.memberShippingDetails.filter((x: any) => x.id === addressDetailId);
                if (shippingAddress && shippingAddress[0]) {
                    this.shippingAddressInfo = shippingAddress[0].shippingAddress;
                }
            }
            this.savedAddressId = address.id;
            address.isShowStateCode = this.checkoutConfig.showStateCode;
            this.shippingAddressInfo = address;
            this.address = address;
            this.address.phone = this.address.phoneNumber;
            this.address.email = this.address.email ? this.address.email : null;
            this.updateTotalsAndShipMethod();
        }
        this.showSavedAddress = false;
        this.pudoAddressSubmitted = false;
    }

    prepareNewAddress(address: any): any {
        if (address) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(+address.countryId, null);
            const stateObj = this.getStateDetailsByStateIdOrCode(+address.stateId, null);

            const addressObj = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                phone: address.phone,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: stateObj.stateCode || '',
                stateId: address.stateId,
                postalCode: address.postalCode,
                country: countryObj.isocodeThree || '',
                countryCodeThree: countryObj.isocodeThree || '',
                countryId: address.countryId,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse
            };
            return addressObj;
        }
    }

    /**
    * This method used to map communication preference
    */
    checkContactSponsor(): void {
        const memberCommunicationPreferences: MemberCommunicationPreference = {
            email: this.orderFormGroup.value.isContactSponsor,
            phone: false
        };
        this.memberCommunicationPreferences = memberCommunicationPreferences;
    }

    /**
       * verified Address Mapping
       * @param  {any}  address
       * @returns any
       */
    private mapVerifiedAddressToFormFields(address: any): any {
        if (address) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, address.country);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, address.state, address.country);
            const mapAddressToFields = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3 ? address.addressLine3 : '',
                addressLine4: address.addressLine4 ? address.addressLine4 : '',
                postalCode: address.postalCode,
                city: address.city,
                stateId: stateObj ? stateObj.id : null,
                stateCode: stateObj ? stateObj.stateCode : null,
                countryCode: countryObj ? (countryObj.countryCode || countryObj.isocodeThree) : null,
                countryId: countryObj ? countryObj.countryId : null,
                phone: address.phone ? address.phone.replace(/[^a-zA-Z0-9]/g, '') : null,
                addressVerified: (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified,
                latitude: address.latitude,
                longitude: address.longitude,
                id: address.id,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null,
                isShowStateCode: this.checkoutConfig.showStateCode
            };
            return mapAddressToFields;
        }
    }

    /**
    * Add new Shipping Address
    * @param shippingAddressForm
    */
    useNewShippingAddress(addressInfo: any) {
        if (addressInfo) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(addressInfo.countryId, null);
            const stateObj = this.getStateDetailsByStateIdOrCode(addressInfo.stateId, null);
            const mappedAddressInfo = {
                shipToName: addressInfo.name,
                firstName: addressInfo.firstName,
                middleName: addressInfo.middleName,
                lastName: addressInfo.lastName,
                addressLine1: addressInfo.addressLine1,
                addressLine2: addressInfo.addressLine2,
                addressLine3: addressInfo.addressLine3,
                addressLine4: addressInfo.addressLine4,
                city: addressInfo.city,
                stateId: stateObj.id,
                stateName: stateObj.stateName || '',
                state: stateObj.stateCode || '',
                stateCode: stateObj.stateCode || '',
                countryId: countryObj.countryId,
                countryName: countryObj.name || '',
                country: countryObj.isocodeThree || '',
                countryCode: countryObj.isocodeThree || '',
                postalCode: addressInfo.postalCode || addressInfo.zip,
                zip: addressInfo.postalCode || addressInfo.zip,
                phone: addressInfo.phone,
                addressVerified: addressInfo.addressVerified,
                latitude: addressInfo.latitude,
                longitude: addressInfo.longitude,
                phoneType: addressInfo.phoneType,
                isShowStateCode: addressInfo.isShowStateCode,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                disableAddressBlock: addressInfo.disableAddressBlock,
                deliveryInstruction: addressInfo.deliveryInstruction,
                email: addressInfo.email ? addressInfo.email : null
            };
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                this.pudoShippingAddressInfo = mappedAddressInfo;
                this.showPudoPickupPersonAddressForm = false;
            } else {
                this.shippingAddressInfo = mappedAddressInfo;
            }
            this.isNewCard = false;
            this.updateTotalsAndShipMethod();
        } else {
            this.showAddressFormValidations = true;
        }
    }
    /**
     * save address method
     */
    private saveAddress(addressDetails: any) {
        const saveAddressRequest: any = {
            id: null,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            addressLine1: addressDetails.addressLine1,
            addressLine2: addressDetails.addressLine2,
            addressLine3: addressDetails.addressLine3 ? addressDetails.addressLine3 : '',
            addressLine4: addressDetails.addressLine4 ? addressDetails.addressLine4 : '',
            shipToName: addressDetails.name,
            city: addressDetails.city,
            stateId: addressDetails.stateId,
            countryId: addressDetails.countryId,
            postalCode: addressDetails.postalCode || addressDetails.zip,
            contactTypeID: 1,
            defaultAddress: false,
            addressVerified: addressDetails.addressVerified,
            latitude: addressDetails.latitude,
            longitude: addressDetails.longitude,
            addressTypeId: 40,
            loggedInUserId: this.memberInfo.userId,
            responseCodes: addressDetails.responseCodes ? addressDetails.responseCodes : null,
            phone: addressDetails.phone,
            phoneNumber: addressDetails.phone,
            firstName: addressDetails.firstName,
            middleName: addressDetails.middleName,
            lastName: addressDetails.lastName,
            phoneType: addressDetails.phoneType,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
            disableAddressBlock: addressDetails.disableAddressBlock,
            deliveryInstruction: addressDetails.deliveryInstruction,
            email: addressDetails.email ? addressDetails.email : null
        };
        this._orderService.saveVerifiedAddress(saveAddressRequest).subscribe(response => {
            if (response && response.addressDetail) {
                if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                    this.pudoAddress = addressDetails;
                    this.pudoAddress.id = response.addressDetail.id;
                    this.savedPudoAddressId = response.addressDetail.id;
                } else {
                    this.verifiedShippingAddressId = response.addressDetail.id;
                    this.address = addressDetails;
                    this.address.id = response.addressDetail.id;
                    // this.address.country = this.address.countryCode;
                    this.orderFormGroup.controls['shippingAddressId'].setValue(response.addressDetail.id, { onlySelf: true });
                    this.savedAddressId = response.addressDetail.id;
                    if (this.shipMethodId && this.shipMethodId.nativeElement) {
                        this.shipMethodId.nativeElement.focus();
                    }
                }
                if (saveAddressRequest.saveForFutureUse) {
                    this.messageService.setAddressSaved(true);
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(false);
                }
            }

        }, error => {
            const notification: any = this._translatePipe.get('order.Unable to Save Member Address');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    }
    reEnterShippingAddress() {
        this.orderFormGroup.get('shippingAddressForm').reset();
    }
    // region #Start ShipMethods Section
    /**
       * on Shipping Method Change
       */
    selectShippingMethod(shippingMethod: ShippingMethod, isDeliveryOptionChange: boolean = false) {
        if (shippingMethod) {
            if (shippingMethod && (shippingMethod.pickUpLocation && (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP))) {
                this.getProductRestrictions(shippingMethod, shippingMethod.pickUpLocation, isDeliveryOptionChange);

                if (this.orderFormGroup.value.shipMethodId) {
                    this.selectedpickup = this.orderFormGroup.value.shipMethodId;
                }
            } else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = 0;
                this.shippingCost = this.isOrderSessionInfo && (this.orderSession.shippingCostValue > 0 || this.orderSession.isShippingDiscountApplied) ?
                    this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                this.originalShippingTax = shippingMethod.shippingTax || 0;
                this.shippingTax = 0;
                this.orginalShippingCost = 0;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this.orginalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                this.calculateOrderTax();
                if (!this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['shippingCostSelector'].setValue(this.selectEnum.firstOption.toString());

                }
                if (isDeliveryOptionChange) {
                    this.updateTotalsAndShipMethod();
                }
            }
        }
    }

    selectPudoCollectionPoint(collectionPoint: CollectionPoint) {
        this.selectedPudoCollectionPoint = collectionPoint;
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
            this.getShipMethods();
        }

    }
    
    getProductRestrictions(shippingMethod: ShippingMethod, pickupAddress: any, isDeliveryOptionChange: boolean = false): void {
        const productRestrictionModel: ProductRestrictionModel = this.prepareProductRestrictionModelRequest(pickupAddress);
        this._commonService.getProductRestrictions(productRestrictionModel).subscribe((response) => {
            if (response && response.success && response.productModels) {
                this.getRestrictedProducts(response.productModels);
                this.taxCalculationStatus = true;
            } else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = this._currencyPipe.getFormatedCurrency(0, this.storeInfo);
                this.shippingCost = this.isOrderSessionInfo ? this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                this.originalShippingTax = shippingMethod.shippingTax || 0;
                this.shippingTax = shippingMethod.shippingTax || 0;
                this.orginalShippingCost = this.memberInfo && this.memberInfo.vatRegistered ? shippingMethod.shippingCharge
                    : shippingMethod.shippingCharge + this.shippingTax;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this.orginalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                this.calculateOrderTax();
                if (!this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['shippingCostSelector'].setValue(this.selectEnum.firstOption.toString());

                }
                if (isDeliveryOptionChange) {
                    this.updateTotalsAndShipMethod();
                }
            }
        });
    }

    /**
     * @description this method used for preparing product restriction odel request for pickup
     * @memberof ShippingAddressNewComponent
     */
    prepareProductRestrictionModelRequest(pickupAddress: any): ProductRestrictionModel {
        let productRestrictionModel: ProductRestrictionModel;
        productRestrictionModel = {
            countryCode: pickupAddress.countryCode,
            stateCode: pickupAddress.stateCode
        };
        const productModel: ProductModel[] = [];
        if (this.products && this.products && this.products.length > 0) {
            this.products.forEach(item => {
                productModel.push({ itemNumber: item.itemNumber });
            });
        }
        productRestrictionModel.productModels = productModel;
        return productRestrictionModel;

    }

    getShippingCost() {
        this.calculateOrderTax();
    }

    /**
     * Get Ship Methods By Products and Store
     */
    getShipMethods(isDeliveryOptionChange: boolean = false) {
        this.taxCalculationStatus = true;
        this.shippingMethods = [];
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.showSelectedShipMethod = false;
        this.shipMethodValidation = null;
        this.restrictedProducts = [];
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
        this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
        this.orderFormGroup.controls['shippingCost'].setValue('');
        if (!this.pudoShippingAddressInfo) {
            this.gtePudoPickupPersonAddress();
        }
        if (this.storeInfo && this.products && this.products.length > 0
            && (this.shippingAddressInfo || (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) || (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP || this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP)) && !this.dropShipDeliveryOptionDisabled) {
            let shippingOptions = this.prepareShippingOptionsRequest();
            if (!shippingOptions.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
            if (!shippingOptions.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
            this._orderService.getShipmentService(shippingOptions).subscribe(response => {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    if (this.shippingAddressInfo || (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled) || (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP || this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP)) {
                        this.shipMethods = response;
                        this.shippingMethods = response.shippingMethods;
                        if (this.shippingMethods.length > 0) {
                            this.shippingMethods.forEach(shipMethod => {
                                shipMethod.shippingCharge = shipMethod.shippingCharge - shipMethod.shippingTax;
                                shipMethod.shippingCharge = this._currencyPipe
                                    .getFormatedCurrency(shipMethod.shippingCharge, this.storeInfo);
                                shipMethod.importFeeEnabled = response.importFeeEnabled;
                            });
                            if (this.isOrderSessionInfo) {

                                this.orderFormGroup.patchValue({
                                    shippingCostSelector: this.orderSession.shippingCostSelector,
                                    originalShippingCost: this.orderSession.originalShippingCost,
                                    shipMethodId: this.orderSession.shipMethodId,
                                    shippingCost: this.orderSession.shippingCost,
                                    shippingCostPercentage: this.orderSession.shippingCostPercentage,
                                    isShippingDiscountApplied: this.orderSession.isShippingDiscountApplied
                                });

                                const shipMethodId = this.orderFormGroup.value.shipMethodId;
                                if (shipMethodId && this.shippingMethods) {
                                    let shippingObj =
                                        this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +shipMethodId)[0];
                                    if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled
                                        && shippingObj && shippingObj.pudoEnabled
                                        && this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
                                        shippingObj = this.shippingMethods.find((shipMethod: any) => shipMethod.pudoEnabled != true);
                                    }
                                    if (shippingObj) {
                                        this.selectShippingMethod(shippingObj, isDeliveryOptionChange);
                                        this.getShippingCost();
                                    }
                                } else {
                                    this.orderFormGroup.patchValue({
                                        shippingCost: 0,
                                        originalShippingCost: 0,
                                        shippingCostPercentage: 0,
                                        isShippingDiscountApplied: false,
                                        originalShippingTax: 0
                                    });

                                    if (this.shippingMethods[0].shippingMethodId) {
                                        let firstShippingMethod = this.shippingMethods[0];
                                        if (this.shippingAddressInfoConfig.pudoLocationsEnabled && firstShippingMethod && firstShippingMethod.pudoEnabled) {
                                            firstShippingMethod = this.shippingMethods.find((x) => x.pudoEnabled != true);
                                        }
                                        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            this.orderFormGroup.controls['shipMethodId']
                                                .setValue(firstShippingMethod.shippingMethodId.toString());
                                        } else {
                                            this.orderFormGroup.controls['shipMethodId'].setValue(firstShippingMethod.shippingMethodId);
                                        }
                                        this.selectShippingMethod(firstShippingMethod, isDeliveryOptionChange);
                                    }
                                }
                            } else {
                                this.orderFormGroup.patchValue({
                                    shippingCost: 0,
                                    originalShippingCost: 0,
                                    shippingCostPercentage: 0,
                                    isShippingDiscountApplied: false,
                                    originalShippingTax: 0
                                });
                                if (this.shippingMethods[0].shippingMethodId) {
                                    let shippingInfoObj: ShippingMethod;
                                    if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
                                            shippingInfoObj = response.shippingMethods.find((x) => !x.pudoEnabled);
                                        }
                                        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
                                            shippingInfoObj = response.shippingMethods.find((x) => x.pudoEnabled);
                                        }
                                        if (this.selectedpickup && this.isPickUpOptionExist && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +this.selectedpickup)[0];
                                        } else {
                                            if(!shippingInfoObj){
                                                shippingInfoObj = this.shippingMethods[0];
                                            }
                                        }
                                        // if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY ) {
                                        this.pudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled);
                                        if (!this.pudoShippingMethod) {
                                            this.getPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                                        } else {
                                            //       this.getPudoLocations();
                                        }
                                        // }
                                        // if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) {
                                        //     shippingInfoObj = this.shippingMethods[0];
                                        //     this.getPudoShippingMethods(shippingOptions, response.shippingMethods);
                                        // }
                                    } else {
                                        if (this.selectedpickup && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +this.selectedpickup)[0];
                                        } else {
                                            shippingInfoObj = this.shippingMethods[0];
                                        }
                                    }
                                    if (shippingInfoObj) {
                                        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            this.orderFormGroup.controls['shipMethodId']
                                                .setValue(shippingInfoObj.shippingMethodId.toString());
                                        } else {
                                            this.orderFormGroup.controls['shipMethodId'].setValue(shippingInfoObj.shippingMethodId);
                                        }
                                        this.selectShippingMethod(shippingInfoObj, isDeliveryOptionChange);
                                    }
                                }
                            }
                            setTimeout(() => {
                                this.orderSession = null;
                                this.isOrderSessionInfo = false;
                            }, 2000);
                        }
                    }
                    //  this.calculateOrderTax();
                } else if (response && response.productModels && response.productModels.length > 0) {
                    this.getRestrictedProducts(response.productModels);
                } else if (response && response.validations.length > 0) {
                    this.shipMethodValidation = response.validations[0];
                } else if (response && !(response.success)) {
                    this.shippingMethods = [];
                    this.shippingCost = 0;
                    this.orderFormGroup.patchValue({
                        shippingCost: 0,
                        originalShippingCost: 0,
                        shippingCostPercentage: 0,
                        isShippingDiscountApplied: false,
                        originalShippingTax: 0
                    });
                }
                if(this.isDropShipOptionExist && !this.pudoShippingMethod){
                    this.getDropShipPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                }
            }, error => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Ship Methods');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        } else {
            this.orderFormGroup.patchValue({
                shippingCost: 0,
                originalShippingCost: 0,
                shippingCostPercentage: 0,
                isShippingDiscountApplied: false,
                originalShippingTax: 0
            });
        }

    }

    getPudoShippingMethods(shippingOptions: ShippingOptionsRequest, shippingMethods: ShippingMethod[], mappingRequired: boolean = true) {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            } else {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
            shippingOptions.shippingTypeId = ShippingType.DROPSHIP;
            //order source only for AUT && DEU Country

            this._orderService.getShipmentService(shippingOptions).subscribe((response) => {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    this.pudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled == true);
                    if (mappingRequired) {
                        if (this.pudoShippingMethod) {
                            this.pudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                        this.getPudoLocations();
                    }
                }
            }, (error) => {
            });
        }
    }

    /**
     * this will prepare shipping options request
     */
    prepareShippingOptionsRequest(): ShippingOptionsRequest {
        const shippingOptions: ShippingOptionsRequest = {
            productModels: this.getProductModels(),
            orderSourceId: OrderSourceType.Web,
            languageCode: this.languageCode,
            orderTypeId: ShippingOrderType.Personal,
            fromAddress: this.getWarehouseAddress(),
            toAddress: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? this.getShippingAddress() : (this.shippingAddressInfoConfig.dropShipLocationsEnabled
                    && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) ? this.getPudoDropShipPersonAddress(this.selectedPudoCollectionPoint) : this.gtePudoPickupPersonAddress(),
            storeId: this.storeInfo.id,
            requestID: 2, // for now we are using two once config is done we will drive from enum
            memberTypeId: this.memberInfo && (this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR || this.memberInfo.memberTypeId === MemberTypeEnum.FPC)
                ? ShippingMemberType.DISTRIBUTOR : ShippingMemberType.RETAIL,   // retail (6) || distributor (4)
            priceTypeId: this.getPriceTypeId(),
            memberLevelId: this.memberInfo && (this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER)
                ? ShippingMemberTitle.NOVUS : ShippingMemberTitle.ASSISTANTMANAGER,
            orderSubTotal: this.subTotal ? this.subTotal : 0,
            orderCaseCredits: this.totalCommissionableVolume,
            purchaseFlowId: this.getPurchaseFlowId(),
            shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY : (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP ? ShippingType.DROPSHIP : ShippingType.PICKUP),
            storeHomeCountryCode: this.selectedIsoCountryCode,
            vatInclusive: this.memberInfo && this.memberInfo.vatRegistered === true ? this.memberInfo.vatRegistered : false,
            initialOrder: false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? true : false
        };
        if (this.shippingAddressInfoConfig.sendSourceToShippingOptions) {
            shippingOptions.source = Source.SERVICE;
        }
        return shippingOptions;
    }


    getPudoDropShipPersonAddress(collectionPoint?: CollectionPoint) {
        let address: any = collectionPoint;
        let dropShipAddress;
        if (collectionPoint) {
            dropShipAddress = {
                addressLine1: address.street ? collectionPoint.street : this.pudoShippingAddressInfo.addressLine1,
                addressLine2: address.address2,
                addressLine3: address.address3,
                city: address.city,
                state: collectionPoint.state,
                stateCode: this.pudoShippingAddressInfo.stateCode || null,
                countryCode: this.selectedIsoCountryCode,
                country: collectionPoint.country || this.selectedIsoCountryCode,
                postalCode: this.pudoShippingAddressInfo.postalCode || null,
                zipCode: address.zipCode,
                countryId: this.pudoShippingAddressInfo.countryId,
                stateId: this.pudoShippingAddressInfo.stateId,
                externalId: address.externalId,
                name: address.name ? this.storeInfo.warehouseAddress.name : null
            }
            this.pudoAddress = dropShipAddress;
            this.dropShipAddress = dropShipAddress;
        }

        return this.dropShipAddress;
    }


    gtePudoPickupPersonAddress(): Address {
        let address: Address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                const mailingAddress = this.memberBasicInfo && this.memberBasicInfo.address ? this.memberBasicInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if (!address.phone) {
                            address.phone = this.memberBasicInfo.phone;
                            address.phoneNumber = this.memberBasicInfo.phone;
                        }
                        if (!address.email) {
                            address.email = this.memberBasicInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        } else {
            address = this.pudoShippingAddressInfo;
        }
        if (this.createOrderInfo) {
            this.pudoAddress = this.address;
        } else {
            this.pudoAddress = this.pudoShippingAddressInfo;
        }
        return address;
    }

    preparePudoLocationRequest() {
        if (!this.countries) {
            this.countries = this._cacheService.get(CacheKey.COUNTRIES);
        }
        let request: PudoLocationRequest = null;
        if (this.pudoLocationSearchForm) {
            let pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
            if (this.pudoAddress) {
                this.pudoAddress.zip = this.pudoAddress.zip ? this.pudoAddress.zip : this.pudoAddress.postalCode;
            }

            if (pudoLocationSearchFormData && pudoLocationSearchFormData.zipCode ? true : this.pudoAddress && this.pudoAddress.zip) {
                if (!pudoLocationSearchFormData.zipCode) {
                    this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
                }
                pudoLocationSearchFormData = this.pudoLocationSearchForm.value
                if (this.countries && this.storeInfo.homeIsocodeThree && pudoLocationSearchFormData.zipCode) {
                    const country: Country = this.countries.find((x: Country) => x.isocodeThree.toUpperCase() === this.storeInfo.homeIsocodeThree.toUpperCase());
                    request = {
                        countryIsoCode: country.isocodeTwo || '',
                        postalCode: pudoLocationSearchFormData.zipCode || '',
                        storeID: this.storeInfo && this.storeInfo.id || null,
                        // as per centiro api we need to send  . (period) if there is no city
                        city: pudoLocationSearchFormData.city || '.',
                        streetAddress: pudoLocationSearchFormData.addressLine1 || ''
                    }
                }
            }
        }
        return request;
    }

    loadPUDOLocations() {
        if (!this.skipAddressVerification) {
            this.messageService.setSubmitPudoPickupPersonAddress(true);
        } else {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                this.messageService.setSubmitPudoDropShipPersonAddress(true);
            }
            this.getPudoLocations();
        }
    }

    getPudoLocations() {
        let pudoLocationRequest: PudoLocationRequest = this.preparePudoLocationRequest();
        if (pudoLocationRequest) {
            this.pudoLocationsNotFound = false;
            this.pudoCollectionPoints = null;
            this.selectedPudoCollectionPoint = null;
            this.loadingPudoPickupLocations = true;
            this._orderService.getPudoLocations(pudoLocationRequest).subscribe(
                (res) => {
                    this.loadingPudoPickupLocations = false;
                    if (res && res.collectionPoints && res.collectionPoints.length) {
                        this.pudoLocationsNotFound = false;
                        res.collectionPoints.sort((x, y) => x.distance - y.distance);
                        this.pudoCollectionPoints = res.collectionPoints;
                        this.prepareBusinessHours();
                        if (this.pudoLocationSearchForm && this.pudoLocationSearchForm.value && this.pudoLocationSearchForm.value.externalId) {
                            this.selectedPudoCollectionPoint = this.pudoCollectionPoints.find((x) => x.externalId == this.pudoLocationSearchForm.value.externalId);
                            if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                this.getShipMethods();
                            }
                        }
                    } else {
                        this.pudoLocationsNotFound = true;
                    }
                }, (error) => {
                    this.loadingPudoPickupLocations = false;
                    this.pudoLocationsNotFound = true;
                }
            );
        }
    }

    prepareBusinessHours(): void {
        if (this.pudoCollectionPoints && this.pudoCollectionPoints.length) {
            this.pudoCollectionPoints.forEach((collectionPoint) => {
                if (collectionPoint && collectionPoint.openingHours) {
                    let businessHours: BusinessHour[] = [];
                    collectionPoint.openingHours.forEach((opening) => {
                        if (opening && opening.hours) {
                            let hours: SplitHour[] = [];
                            opening.hours.forEach((hour) => {
                                hours.push({ start: hour.opens, end: hour.closes })
                            });
                            const businessHour: BusinessHour = {
                                available: true,
                                day: opening.dayText,
                                hours: hours
                            }
                            businessHours.push(businessHour);
                        }
                    });
                    collectionPoint.businessHours = businessHours;
                }
            });
        }
    }
    /** Products
    * @returns Products
    */
    private getProductModels(): ShippingProductModel[] {
        // const items: any = this.orderFormGroup.get('items');
        const productModels: ShippingProductModel[] = [];
        if (this.products && this.products.length > 0) {

            for (let index = 0; index < this.products.length; index++) {

                const product = this.products[index];
                if (product) {
                    const productModel: ShippingProductModel = {
                        productID: product.id,
                        productHeight: product.shipping ? product.shipping.height : 0,
                        productWeight: product.shipping ? product.shipping.weight : 0,
                        productQuantity: product.quantity,
                        productLength: product.shipping ? product.shipping.length : 0,
                        productWidth: product.shipping ? product.shipping.width : 0,
                        wholesalePrice: product.wholesalePrice,
                        sellingPrice: product.applicablePrice,
                        isOrderLiteratureOnly: product.literature,
                        retailPrice: product.retailPrice,
                        weightMetricId: ProductWeightMetric.KGS,
                        isShippable: product.shipping ? product.shipping.shippingRequired : 0,
                        itemNumber: product.itemNumber
                    };
                    productModels.push(productModel);
                }

            }

        }
        return productModels;
    }

    // endregion

    // region #Start Products Section
    /**
    * @param  {any} data
    * @returns SafeHtml
    */
    autocompleListFormatter = (data: any): SafeHtml => {

        const html = `<span>${data.itemNumber} - ${this._titleCase.transform(data.displayName ? data.displayName : data.name)}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    /**
     * Auto Complete Product Search
     */
    observableSource = (keyword: any, fullSearch?: boolean): Observable<any[]> => {
        let fpc5PercentEnabled: boolean = false;
        if (this.memberInfo && this.serviceOrderPermissions && this.storeInfo) {
            if (keyword && keyword.length > 1) {
                if (keyword.indexOf('#') == 0) {
                    keyword = keyword.replace(/#/, '');
                }
                if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
                    fpc5PercentEnabled = true;
                }
                let wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified ? true : false;
                if (wholesaleQualified == null) {
                    wholesaleQualified = false;
                }
                const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
                /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
                    Level, Opt-In, and Wholesale Qualified Status*/
                let memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
                const purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
                // HARD_DOWNGRADE CHECK FOR FPC USERS
                if (this.memberInfo) {
                    memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
                }

                let _itemNumberURL = environment.productsUrl + '/stores/' + this.storeInfo.id + '/customerservice/products' +
                    '?languageCode=' + this.storeDefaultLanguage + '&memberTitleId=' + memberTitleId +
                    '&countryCode=' + this.selectedIsoCountryCode + '&pageSize=10&pageNumber=1&wholesaleQualified='
                    + wholesaleQualified + '&productWildSearch=' + keyword.trim() + '&source=' + ProductSource.ADMINISTRATION +
                    '&optin=' + optin + '&taxInclusive=' + this.storeInfo.taxInclusive;
                if (fullSearch) {
                    _itemNumberURL += '&searchType=FULL';
                }
                return this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(res => {
                    const results = res.json();
                    if (results && results.length > 0) {
                        return results;
                    } else {
                        return [];
                    }
                });
            } else {
                return Observable.of([]);
            }
        } else {
            let notification: any;
            if (!this.memberInfo) {
                notification = this._translatePipe.get('order.Member Details are Mandatory');
            }
            if (!this.storeInfo && !this.countryCode && !this.pickupDeliveryOptionAvailable && !this.shippingDeliveryOptionAvailable) {
                notification = this._translatePipe.get('Shipping options not available');
            } else if (!this.storeInfo && !this.countryCode &&
                (this.pickupDeliveryOptionAvailable || this.shippingDeliveryOptionAvailable)) {
                notification = this._translatePipe.get('order.Country Details are Mandatory');
            }
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
    }
    /**
     * Decrement the item Quantity
     * @returns void
     */
    decrementQuantity(index: number): void {
        this.taxCalculationStatus = true;
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            this.setFocusbyID('quantity-' + (index));
            this.updateTotalsAndShipMethod();
        }
    }

    /**
    * Increment the item Quantity
    * @returns void
    */
    incrementQuantity(index: number): void {
        this.taxCalculationStatus = true;
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            const product = items.controls[index].controls['productItem'].value;
            if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock) && !(product.stockAvailable && !product.manageStock)) {
                items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);

                items.controls[index].controls['disableIncrement'].setValue(true);
            } else {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            // items.controls[index].controls['disableIncrement'].setValue(false);
            items.controls[index].controls['quantity'].updateValueAndValidity();
            this.setFocusbyID('quantity-' + (index));
            this.updateTotalsAndShipMethod();
        }
    }


    quantityChange(event: any, index: number) {
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    }
    /**
    * @param  {number} index
    * @returns void
    */
    updateQuantity(event: any, index: number): void {
        if (!this.isRestrictionPopupOpened && !this.addNewCardClicked) {
            const items: any = this.orderFormGroup.get('items');
            if (items && items.length > 0 && this.storeInfo) {
                if (items.controls[index].controls['quantity'].value > 1 ||
                    (event.target.value && parseInt(event.target.value, 10))) {
                    const product = items.controls[index].controls['productItem'].value;
                    if (product && event.target.value > product.stockQuantity && product.manageStock) {
                        items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                        const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                        this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                        items.controls[index].controls['disableIncrement'].setValue(true);
                    } else {
                        items.controls[index].controls['quantity'].setValue(event.target.value);
                        items.controls[index].controls['disableIncrement'].setValue(false);
                    }

                    items.controls[index].controls['quantity'].updateValueAndValidity();
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod();
                }
                this.isFocused = false;
            }
        }
    }

    /**
     * @description open/close when restricted products shown
     * @param {boolean} isOpen
     * @memberof ServiceOrderComponent
     */
    restrictionPopupOpen(isOpen: boolean): void {
        this.isRestrictionPopupOpened = isOpen;
    }

    /**
     * disabling Submit button
     */
    disableSubmitButton(): void {
        this.taxCalculationStatus = true;
    }

    /**
     * @returns void
     */
    deleteItem(index: number): void {
        const items = this.orderFormGroup.get('items') as any;
        if (items && items.length > 0) {
            items.removeAt(index);
        }
        setTimeout(() => {
            if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                this.itemLevelSearch.nativeElement.focus();
            }
        }, 500);
        this.updateTotalsAndShipMethod();
    }
    confirm(index: number) {
        if (index === 0 || index > 0) {
            this.deleteItem(index);
        }
        // this.quickOrderNumberItemModal.hide();
    }

    addItemNumber(): void {
        this.items = this.orderFormGroup.get('items') as any;
        this.items.push(this.createItemNumberGroup());
    }

    // endregion

    // region #Start Common Methods Section
    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    public clearAllTheForms(clearCountry: boolean = true, clearShippingAddress: boolean = true, clearMember: boolean = false) {
        this.showSelectedShipMethod = false;
        this.shippingAddressInfo = null;
        this.selectedpayvisionCardInfo = null;
        this.shipMethod = null;
        this.subTotal = 0;
        this.retailSubTotal = 0.0;
        this.shippingCost = 0;
        this.shippingTax = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        this.verifiedShippingAddressId = 0;
        this.memberLevelHistory = [];
        this.isMemberFboUpgraded = false;
        this.isFBOValidationPending = false;
        this.personalInformation = null;
        this.mailingAddress = null;
        this.liveFormAddress = null;
        this.address = null;
        this.sponsorInformation = null;
        this.isSubmitted = false;
        this.shippingAddressInfoConfig = null;
        this.businessEntityId = null;
        this.orderFormGroup.get('items').reset();
        const arr = <FormArray>this.orderFormGroup.controls.items;
        arr.controls = [];
        this.orderFormGroup.controls['isContactSponsor'].setValue(null);
        this.memberCommunicationPreferences = {
            email: null,
            phone: false
        };
        this.orderFormGroup.patchValue({
            shippingCostSelector: this.selectEnum.firstOption.toString(),
            shippingCostPercentage: 0,
            originalShippingCost: 0,
            paymentSelector: this.selectEnum.firstOption.toString(),
            paymentInstrumentId: '',
            isShippingDiscountApplied: false,
            originalShippingTax: 0
        });
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (clearCountry) {
            this.orderFormGroup.controls['countryId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['countryId'].updateValueAndValidity();
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL && this.stores && this.stores.length > 0) {
                const countryId = this.stores.find(store => store.isocodeThree.toUpperCase() === IsoCodeThree.USA).id || this.stores[0].id;
                this.orderFormGroup.controls['countryId'].setValue(countryId);
                this._enrollmentMessageService.setClearGuestForm();
            } else {
                this.orderFormGroup.controls['countryId'].setValue('');
            }
            this.memberCountries = [];
        }
        if (clearMember) {
            this.orderFormGroup.controls['memberInfo'].setValidators([Validators.required]);
            this.orderFormGroup.controls['memberInfo'].updateValueAndValidity();
            this.orderFormGroup.controls['memberInfo'].setValue('');
            this.memberInfo = null;
        }

        if (clearShippingAddress) {
            this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
            this.orderFormGroup.controls['shippingAddressId'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingAddressId'].setValue('');
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.DELIVERY);
            this.shippingMethods = [];
            this.memberAddressDetails = [];
        }
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['backDateOrder'].setValue(false);
        this.orderFormGroup.controls['itemSearch'].setValue('');
        this.orderFormGroup.markAsUntouched();
        this.updateTotalsAndShipMethod();
        this.orderTaxResponse = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.pudoShippingAddressInfo = null;
        this.showPudoPickupPersonAddressForm = false;
        this.pudoAddress = null;
        this.savedPudoAddressId = null;
        this.pudoAddressSubmitted = false;
        this.buildPudoLocationSearchForm();
        this.loadingPudoPickupLocations = false;
        this.displayPudoAddress = false;
        this.showDropShipPersonAddressForm = false;
    }

    /**
     * update Totals and ShipMethod
     */
    updateTotalsAndShipMethod() {
        this.taxCalculationStatus = true;
        this.subTotal = 0;
        this.retailSubTotal = 0;
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.itemCount = this.shoppingCartCount;
        }
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            for (let index = 0; index < items.length; index++) {
                const product = items.controls[index].controls['productItem'].value;
                const quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    const existProduct = this.products.filter(productObj => productObj.id === product.id)[0];
                    if (!existProduct) {
                        product.quantity = quantity;
                        this.products.push(product);

                    } else {
                        const productIndex = this.products.findIndex(item => item.id === existProduct.id);
                        this.products[productIndex].quantity = this.products[productIndex].quantity + quantity;
                    }
                    if (this.appConfig && this.appConfig.freeShippingFPCOrder) {
                        this.getMemberShippingDiscountOffer(this.memberInfo.memberId);
                    } else {
                        this.memberShippingDiscountOfferEligible = false;
                    }
                    const shippingAddress = this.getShippingAddress();
                    if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
                        const country = this.countries.find(x => x.countryId === shippingAddress.countryId);
                        this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
                    }
                    const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
                    const taxCalculated = this.appConfig.displayTaxInclusivePrice ? false : true;
                    this.displayPriceConfig = this._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this.storeInfo.taxInclusive,
                            this.memberInfo, taxCalculated, this.countryTaxInclusive, this.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                    let price: number = this.countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    let retailPrice: number = product.retailPrice;
                    if (this.displayPriceConfig) {
                        price = this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice : product.catalogPrice);
                        retailPrice = this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            (this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice);
                    }
                    this.subTotal = this.subTotal + this.getItemTotalSum(product);
                    this.retailSubTotal = 0.0;
                    this.totalCommissionableVolume = 0;
                    this.shoppingCartCount += +product.quantity;
                }
            }
            if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
                this.itemCount = this.shoppingCartCount - this.itemCount;
            } else {
                this.itemCount = this.shoppingCartCount;
            }
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && !(this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                const subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
                const literatureItems = this.getLiteratureItems(this.products);
                if (this.isMemberFboUpgraded) {
                    this.upgradeFboLimitExceeded = this.validateMemberMonthlyAmountLimit(subTotal);
                    if (this.upgradeFboLimitExceeded) {
                        this.checkMemberAccess();
                        this.getShipMethods();
                        return;
                    } else {
                        this.isMemberHasAccessToOrder = true;
                    }
                }
                if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                    || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                        && subTotal <= this.orderRules.maxValue))) {
                    if (this.appConfig.orderMinMaxPriceValidation) {
                        this.minMaxPriceValidation = true;
                    }
                } else {
                    this.cartLimitExceed = false;
                    this.cartLimitNotReach = false;
                    this.minMaxPriceValidation = false;
                }
            }
            else {
                this.itemCount = 0;
            }
            this.getShipMethods();
        } else {
            this.gstTax = 0;
            this.pstTax = 0;
            this.shippingCost = 0;
            this.shippingTax = 0;
            this.importFeeValue = 0;
        }
    }
    /**
     * calculateSubtotalWithWholesalePrice()
     * @param shoppingCart
     */
    calculateSubtotalWithWholesalePrice(orderSubTotal: number): number {
        let subTotal = orderSubTotal;
        if (this.products && this.products.length &&
            this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
            && this.appConfig.displayPurchaseLimitationMessage
            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
            subTotal = 0;
            this.products.forEach(item => {
                subTotal += ((this.countryTaxInclusive ? item.wholesalePrice : item.baseWholesalePrice) * item.quantity);
            });
            // Should not apply wholesale price when user exceeds limit,
            // Wholesale price calculation applicable for minimum limit restriction
            if (orderSubTotal > this.orderRules.maxValue) {
                subTotal = orderSubTotal;
            }
        }
        return subTotal;
    }

    /**
 * @description formatting dob to the yyyy-mm-dd
 * @param {LegalRequirements} legalRequirements
 * @returns {LegalRequirements}
 * @memberof ServiceOrderComponent
 */
    dateOfBirthFormat(legalRequirements: LegalRequirements): LegalRequirements {
        const characterCheck = /[a-zA-z]/;
        if (typeof legalRequirements.dateOfBirth._i === DateConstants.Object) {
            legalRequirements.dateOfBirth = legalRequirements.dateOfBirth._d;
            legalRequirements.dateOfBirth = this.momentConstructor(new Date(legalRequirements.dateOfBirth))
                .format(DateConstants.DOBFormat);
        }
        if (typeof legalRequirements.dateOfBirth._i === DateConstants.String) {
            legalRequirements.dateOfBirth = legalRequirements.dateOfBirth._i;
            const dateParts = legalRequirements.dateOfBirth.split('-');
            if (characterCheck.test(dateParts[1])) {
                legalRequirements.dateOfBirth = this.momentConstructor(new Date(legalRequirements.dateOfBirth))
                    .format(DateConstants.DOBFormat);
            } else {
                legalRequirements.dateOfBirth = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                    .format(DateConstants.DOBFormat);
            }
        }
        return legalRequirements;
    }

    /**
    * Government ID changes
    * @memberof PersonalInfoComponent
    */
    governmentIdChanges(): void {
        this.invalidGovernmentId = false;
        this.governmentIdExist = false;
    }

    /**
     * @description
     * @param {*} dateMomentObj
     * @memberof ServiceOrderComponent
     */
    convertToSpecificDateFormat(dateMomentObj: any) {
        const characterCheck = /[a-zA-z]/;
        const dateInputPattern = /^[a-zA-Z0-9\-]*$/;
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj._i === 'object') {
            dateMomentObj = dateMomentObj._d;
            this.fboUpgradeForm.patchValue({
                dateOfBirth: moment(dateMomentObj, 'DD-MMM-YYYY')
            });
        }
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj.value._i === DateConstants.String) {
            dateMomentObj = dateMomentObj.value._i;
            if (dateInputPattern.test(dateMomentObj)) {
                const dateParts = dateMomentObj.split('-');
                if (characterCheck.test(dateParts[1])) {
                    dateMomentObj = moment(dateMomentObj, DateConstants.DateFormat);
                } else {
                    dateMomentObj = moment(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                        .format(DateConstants.DateFormat);
                }
                this.fboUpgradeForm.patchValue({
                    dateOfBirth: moment(dateMomentObj, DateConstants.DateFormat)
                });
                this.datePickerStartDateAt = new Date(dateMomentObj);
            } else {
                this.datePickerStartDateAt = new Date();
            }
        }
    }

    /**
     * @description
     * @param {FormControl} governmentIdControl
     * @memberof ServiceOrderComponent
     */
    validateGovernmentId(governmentIdControl: FormControl): void {
        this.governmentIdExist = false;
        this.invalidGovernmentId = false;
        const governmentId = governmentIdControl.value;
        const isGovernmentIdValid = governmentIdControl.valid;
        if (governmentId && governmentId.length > 0 && isGovernmentIdValid) {

            this.governmentIdValidInProgress = true;
            this._documentService.validateGovernmentId(governmentId,
                this.countryCode, this.storeId, this.memberId)
                .subscribe((response: any) => {
                    this.invalidGovernmentId = false;
                    if (response && response._body === 'false') {
                        this.governmentIdExist = false;
                    } else {
                        this.governmentIdExist = true;
                    }
                    this.governmentIdValidInProgress = false;
                }, (errResponse: any) => {
                    if (errResponse) {
                        this.governmentIdExist = false;
                        this.governmentIdValidInProgress = false;
                        const response = JSON.parse(errResponse._body);
                        if (response && response.validations && !response.statusCode
                            && response.validations.length > 0) {
                            // this.governmentIdValidations = response.validations;
                            this.invalidGovernmentId = true;
                        } else {
                            this.invalidGovernmentId = false;
                        }
                    }
                });
        }
    }
    // endregion
    /**
     * Selected Shipping Address
     */
    getShippingAddress(address: any = null): any {
        let shippingAddress = null;
        if (address) {
            shippingAddress = address;
        } else {
            shippingAddress = this.shippingAddressInfo;
        }
        if (shippingAddress) {
            const mappedAddress: any = {
                addressLine1: shippingAddress.addressLine1,
                addressLine2: shippingAddress.addressLine2,
                addressLine3: shippingAddress.addressLine3,
                addressLine4: shippingAddress.addressLine4,
                addressVerified: shippingAddress.addressVerified,
                latitude: shippingAddress.latitude,
                longitude: shippingAddress.longitude,
                city: shippingAddress.city || null,
                state: shippingAddress.stateName,
                stateCode: shippingAddress.stateCode,
                countryCode: shippingAddress.countryCode,
                country: shippingAddress.countryName,
                postalCode: shippingAddress.postalCode ? shippingAddress.postalCode.toUpperCase() : null,
                zip: shippingAddress.postalCode ? shippingAddress.postalCode.toUpperCase() : null,
                countryId: shippingAddress.countryId,
                stateId: shippingAddress.stateId,
                name: shippingAddress.shipToName,
                firstName: shippingAddress.firstName,
                middleName: shippingAddress.middleName,
                lastName: shippingAddress.lastName,
                addressType: this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP ?
                    AddressType.PICKUP_PERSON : AddressType.SHIPPING,
                isShowStateCode: shippingAddress.isShowStateCode,
                phone: shippingAddress.phone ? this.getValidPhoneNumber(shippingAddress.phone) : null,
                phoneNumber: shippingAddress.phoneNumber ? this.getValidPhoneNumber(shippingAddress.phoneNumber) : shippingAddress.phone ? this.getValidPhoneNumber(shippingAddress.phone) : null,
                countryCodeTwo: this.selectedCountryCodeTwo,
                phoneType: shippingAddress.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction: shippingAddress.deliveryInstruction,
                email: shippingAddress.email ? shippingAddress.email : null
            };
            return mappedAddress;
        }
        return null;
    }
    getValidPhoneNumber(phoneNumber: string) {
        if (phoneNumber && this.storeInfo && this.storeInfo.foreverDirectEnabled) {
            phoneNumber = phoneNumber.replace(/[a-zA-Z ]/g, '');
            if (phoneNumber.substring(0, 1) !== '+' && phoneNumber.substring(0, 2) !== '00') {
                phoneNumber = '+' + phoneNumber;
            }
        }
        else {
            phoneNumber = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        }
        return phoneNumber;
    }
    /**
 * Selected Shipping Address
 */
    getBillingAddress(): any {
        let countryId = 0;
        if (this.countries && !this.billingAddressInfo.countryId) {
            let billingCountry: Country;
            if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length > 2) {
                billingCountry =
                    this.countries.find((x: any) => x.isocodeThree.toLowerCase()
                        === this.billingAddressInfo.countryCode.toLowerCase());
            } else if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length === 2) {
                billingCountry =
                    this.countries.find((x: any) => x.isocodeTwo.toLowerCase()
                        === this.billingAddressInfo.countryCode.toLowerCase());
            }
            if (billingCountry) {
                countryId = billingCountry.countryId;
            }
        }
        const stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        const billingAddress: any = {
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2,
            addressLine3: this.billingAddressInfo.addressLine3,
            addressLine4: this.billingAddressInfo.addressLine4,
            city: this.billingAddressInfo.city || null,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            countryCode: this.billingAddressInfo.countryCode,
            country: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            zip: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            countryId: this.billingAddressInfo.countryId || countryId,
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            addressType: AddressType.BILLING,
            countryCodeTwo: this.selectedCountryCodeTwo
        };
        return billingAddress;
    }

    getPickUpAddress(): any {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            this.pudoShippingMethod.pickUpLocation.addressType = AddressType.PICKUP;
            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoShippingMethod.pickUpLocation.stateCode);
            if (countryObj) {
                this.pudoShippingMethod.pickUpLocation.countryId = countryObj.countryId;
            }
            if (stateObj) {
                this.pudoShippingMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.pudoShippingMethod.pickUpLocation.name = this.pudoShippingMethod.pickUpLocation.pickupCenterName;
            this.pudoShippingMethod.pickUpLocation.postalCode = this.pudoShippingMethod.pickUpLocation.zip;
            return this.pudoShippingMethod.pickUpLocation;
        } else if (this.shipMethod && this.shipMethod.pickUpLocation
            && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            this.shipMethod.pickUpLocation.addressType = AddressType.PICKUP;

            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, this.shipMethod.pickUpLocation.stateCode);

            if (countryObj) {
                this.shipMethod.pickUpLocation.countryId = countryObj.countryId;
            }
            if (stateObj) {
                this.shipMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.shipMethod.pickUpLocation.name = this.shipMethod.pickUpLocation.pickupCenterName;
            this.shipMethod.pickUpLocation.postalCode = this.shipMethod.pickUpLocation.zip;
            return this.shipMethod.pickUpLocation;
        }
        return null;
    }

    getPudoPickUpAddress(address: Address, shippingMethod: ShippingMethod): any {
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled) &&
            this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {

            const pudoCollectionPoint = this.selectedPudoCollectionPoint;
            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoAddress.stateCode);
            const pudoPickUpAddress: any = {
                addressLine1: pudoCollectionPoint.street ? (pudoCollectionPoint.street + ' ' + pudoCollectionPoint.houseNumber) : '',
                addressLine2: pudoCollectionPoint.address2 ? pudoCollectionPoint.address2 : '',
                addressLine3: pudoCollectionPoint.address3 ? pudoCollectionPoint.address3 : '',
                addressLine4: null,
                city: pudoCollectionPoint.city,
                state: pudoCollectionPoint.state,
                stateCode: address.stateCode,
                countryCode: address.countryCode,
                country: address.country,
                county: null,
                zip: pudoCollectionPoint.zipCode,
                company: null,
                name: pudoCollectionPoint.name,
                pickupCenterName: pudoCollectionPoint.name,
                instruction: '',
                optionName: DelivaryOptionType.Pickup,
                pickUpCenterId: shippingMethod && shippingMethod.pickUpLocation &&
                    shippingMethod.pickUpLocation.pickUpCenterId ? shippingMethod.pickUpLocation.pickUpCenterId : null,
                latitude: pudoCollectionPoint.geoPoint.latitude + '',
                longitude: pudoCollectionPoint.geoPoint.longitude + '',
                countryId: countryObj.countryId,
                stateId: stateObj.id,
                businessInformation: [],
                residential: false,
                validAddress: false,
                addressType: AddressType.PUDO,
                postalCode: pudoCollectionPoint.zipCode,
                pudoNetwork: pudoCollectionPoint.network,
                pudoExternalId: pudoCollectionPoint.externalId,
                pudoIdentifier: pudoCollectionPoint.identifier
            };
            return pudoPickUpAddress;
        }
    }
    /**
 *
 * @param shippingMethod
 */
    getShippingMethodWarehouseAddress(): Address {
        if (this.shipMethod && this.shipMethod.warehouseAddress) {
            this.shipMethod.warehouseAddress.postalCode = this.shipMethod.warehouseAddress.zip;
            this.shipMethod.warehouseAddress.country = this.shipMethod.warehouseAddress.countryCode;
            return this.shipMethod.warehouseAddress;
        }
    }

    /**
     * Store Ware house Address
     */
    getWarehouseAddress(): Address {
        let warehouseAddress: Address = null;
        if (this.storeInfo && this.storeInfo.warehouseAddress) {
            warehouseAddress = {
                addressLine1: this.storeInfo.warehouseAddress.addressLine1,
                addressLine2: this.storeInfo.warehouseAddress.addressLine2,
                addressLine3: this.storeInfo.warehouseAddress.addressLine3,
                addressLine4: this.storeInfo.warehouseAddress.addressLine4,
                city: this.storeInfo.warehouseAddress.city,
                state: this.storeInfo.warehouseAddress.stateCode,
                stateCode: this.storeInfo.warehouseAddress.stateCode,
                countryCode: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                country: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                postalCode: this.storeInfo.warehouseAddress.zipCode,
                zip: this.storeInfo.warehouseAddress.zipCode,
                countryId: this.storeInfo.warehouseAddress.countryId,
                stateId: this.storeInfo.warehouseAddress.stateOrProvinceId,
                name: this.storeInfo.warehouseAddress.name ? this.storeInfo.warehouseAddress.name : null
            };
        }
        return warehouseAddress;
    }


    private getPurchaseFlowId(): PurchaseFlowType {
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            return PurchaseFlowType.Retail;
        } else {
            return PurchaseFlowType.WholeSale;
        }
    }
    private getPriceTypeId(): PriceType {
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            return PriceType.RETAILPRICE;
        } else {
            return PriceType.WHOLESALEPRICE;
        }
    }

    /**
     * verifyOrderRules
     * @returns boolean
     */
    verifyOrderRules(isBackOrderDate: boolean): any {
        let valid: any;
        valid = { thresholdCrossed: false, monthlyCCValid: false, memberCCOverride: false, cartLimitExceed: false, cartLimitNotReach: false, purchaseLimitExceed: false };
        let monthlyCCValid = false;
        let thresholdCrossed = false;
        const totalPoints = this.calculateTotalPoints();
        const subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
        const literatureItems = this.getLiteratureItems(this.products);
        valid.purchaseLimitExceed = this.validateMemberMonthlyAmountLimit(totalPoints);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints >= this.orderRules.minValue && totalPoints <= this.orderRules.maxValue)) {
            thresholdCrossed = false;
        } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
            if (this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                thresholdCrossed = this.validateSubTotalBasedOnType(this.products, subTotal);
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                } else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            } else if ((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
            } else {
                thresholdCrossed = true;
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                } else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        } else {
            thresholdCrossed = true;
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                } else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        }
        if (this.memberInfo && this.memberOrderCCInfo) {
            let maxValue;
            if (!this.appConfig.displayPurchaseLimitationMessage && (this.orderRules &&
                this.orderRules.valueType === ValueType.PRICE && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                maxValue = this.orderRules.maxCCValue > this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && this.orderRules.monthlyValueType === ValueType.CC) {
                maxValue = this.orderRules.maxCCValue >= this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                maxValue = this.orderRules.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            } else {
                maxValue = this.orderRules && this.orderRules.maxValue > this.memberOrderCCInfo.maxValue
                    ? this.orderRules.maxValue : this.memberOrderCCInfo.maxValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxValue;
            }

            if ((totalPoints + this.memberOrderCCInfo.actualCCValue) > maxValue) {
                monthlyCCValid = true;
                thresholdCrossed = false;
            }

            // Monthly CC override for member
            if (this.memberCCOverride && this.memberCCOverride.overrideFlag) {
                const currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
                const endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                    .format(DateConstants.DateFormat);
                if (!isBackOrderDate) {
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    } else if ((this.orderRules && this.orderRules.maxValue < this.memberCCOverride.cVLimit)
                        && ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        monthlyCCValid = false;
                    }
                } else {
                    const createdDate = this.momentConstructor(this.memberCCOverride.effectiveStartDate)
                        .format(DateConstants.DateFormat);
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(createdDate).getMonth() + 1 <= new Date().getMonth())) {
                        valid.memberCCOverride = true;
                    } else if ((this.orderRules && this.orderRules.maxValue < this.memberCCOverride.cVLimit) &&
                        ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(createdDate).getMonth() + 1 <= new Date().getMonth())) {
                        monthlyCCValid = false;
                    }
                }
            }
        }
        if (!totalPoints) {
            monthlyCCValid = false;
        }
        valid.thresholdCrossed = thresholdCrossed;
        valid.monthlyCCValid = monthlyCCValid;
        // for order rule value type: BOTH
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            const totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            let details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(
                this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC
            );
            valid.cartLimitExceed = details.cartLimitExceed;
            valid.cartLimitNotReach = details.cartLimitNotReach;
            valid.monthlyCCValid = details.monthlyCCValid;
            valid.monthlyCCValue = details.monthlyCCValue;
            valid.thresholdCrossed = details.thresholdCrossed;
        }
        return valid;
    }

    getLiteratureItems(products: any[]): any[] {
        let literatureItems;
        if (products && products.length) {
            literatureItems = products.filter(item => item.literature);
            if (this.orderRules && this.orderRules.itemNumbers && this.orderRules.itemNumbers.length) {
                const tripackItems = products.filter(item => this.orderRules.itemNumbers.indexOf(+item.itemNumber) > -1);
                if (tripackItems && tripackItems.length) {
                    literatureItems.push(tripackItems);
                }
            }
        }
        return literatureItems;
    }

    validateMemberMonthlyAmountLimit(totalPoints): boolean {
        let purchaseLimitExceed = false;
        const memberOrderRules: MemberOrderCCInfo = this.memberOrderCCInfo;
        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE
            && memberOrderRules && (totalPoints + memberOrderRules.actualTotalValue) > this.orderRules.maxValue) {
            purchaseLimitExceed = true;
        }
        return purchaseLimitExceed;
    }

    /**
     * Get total points
     */
    calculateTotalPoints(): number {
        let _totalCV = 0;
        for (let i = 0; i < this.products.length; i++) {
            if (!this.products[i].literature) {
                _totalCV += this.products[i].commissionableVolume * this.products[i].quantity;
            }
        }
        return _totalCV;
    }

    subscribeSaveAddress() {
        this.messageService.getAddressSaved().subscribe(data => {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPHIP) {
                if (!this.pudoAddress) {
                    this.pudoAddress = {};
                }
                this.pudoAddress.isSavedAddress = data;
            } else {
                if (!this.address) {
                    this.address = {};
                }
                this.address.isSavedAddress = data;
            }
        });
    }

    /**
  * on click of checkout
  * @memberof CartComponent
  */
    createOrder(): void {
        if (!this.orderFormGroup.value.shipMethodId) {
            this.getShipMethods();
        }
        this.verifyAddressButtonClicked = false;
        //    if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled
        //     && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP && !this.pudoAddressSubmitted) {
        //     this.messageService.setSubmitPudoPickupPersonAddress(true);
        //     return;
        // }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled
            && !this.selectedPudoCollectionPoint && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
            return;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled
            && !this.selectedPudoCollectionPoint && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
            return;
        }
        if (this.isWhosaleCheckNotCalculated) {
            this.wholesaleCheckErrorNotifications();
            return;

        }
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        this._cacheService.set(CacheKey.CARTUPDATED, 'true');
        if (this.isMemberHasAccessToOrder && !this.upgradeFboLimitExceeded) {
            this.isSubmitted = true;
            if (!this.chRef['destroyed']) {
                this.chRef.detectChanges();
            }
            if (this.products && this.products.length) {
                const productIds = this.products.map((item: Product) => item.id);
                if (productIds && productIds.length) {
                    const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
                        ? this.memberInfo.wholeSaleQualified : false;
                    const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
                    let memberTitleId = this.memberInfo && this.memberInfo.memberTitleId;
                    let purchaseFlowType = PurchaseFlows.PERSONAL;
                    if (this.memberTypeId === MemberTypeEnum.GUEST || this.memberTypeId === MemberTypeEnum.RETAIL) {
                        purchaseFlowType = PurchaseFlows.RETAIL;
                    }
                    // HARD_DOWNGRADE CHECK FOR FPC USERS
                    memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);

                    if (this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DELIVERY || (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled))) {
                        this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id,
                            memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe((products: Product[]) => {
                                this.outOfStockItems = this.stockAvailabilityCheck(products);
                                if (this.outOfStockItems.length) {
                                    this.outOfStockModal.open();
                                    this.isSubmitted = false;
                                } else {
                                    this.submitOrder();
                                }
                            });
                    } else if (this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.PICKUP) {
                        // pickup products stock availability check
                        let shipMethodId = this.orderFormGroup.value.shipMethodId;
                        if (shipMethodId && this.shippingMethods) {
                            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                if (this.pudoShippingMethod && this.pudoShippingMethod.pickUpLocation && this.pudoShippingMethod.pickUpLocation.pickUpCenterId) {
                                    shipMethodId = this.pudoShippingMethod.pickUpLocation.pickUpCenterId;
                                    const shippingObj =
                                        this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +shipMethodId)[0];
                                    if (shippingObj && shippingObj.shippingMethodId) {
                                        this.pickupStockAvailabilityCheck(productIds, shippingObj.shippingMethodId);
                                    } else {
                                        this.isSubmitted = false;
                                    }
                                } else {
                                    this.isSubmitted = false;
                                }
                            } else {
                                const shippingObj =
                                    this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +shipMethodId)[0];
                                if (shippingObj && shippingObj.shippingMethodId) {
                                    this.pickupStockAvailabilityCheck(productIds, shippingObj.shippingMethodId);
                                } else {
                                    this.isSubmitted = false;
                                }
                            }

                        } else {
                            this.isSubmitted = false;
                            const notification = 'Pickup location not available, Please select.'
                            this._commonService.createNotification('', notification, NotificationType.ERROR);
                        }
                    }
                }
            }
        }
    }

    /**
     * @description To check stock available
     * @param {Product[]} products
     * @returns {Product[]}
     * @memberof ServiceOrderComponent
     */
    stockAvailabilityCheck(products: Product[]): Product[] {
        const cartProducts: Product[] = this.products;
        if (cartProducts && products && products.length) {
            const noStockItems: Product[] = [];
            products.forEach((product: Product) => {
                const cartItem = cartProducts.find((item: Product) => item.id === product.id);
                if (cartItem && !((product.stockAvailable && !product.manageStock) || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                    cartItem.stockQuantity = product.stockQuantity;
                    noStockItems.push(cartItem);
                }
            });
            return noStockItems;
        }
        return [];
    }

    /**  validateThreshold(): void {
         const totalPoints = this.calculateTotalPoints();
         const subTotal = this.calculateItemsSubTotal(this.storeInfo);
         if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
             totalPoints <= this.orderRules.maxValue) {
             this.thresholdCrossed = false;
         } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
             subTotal <= this.orderRules.maxValue) {
             this.thresholdCrossed = false;
         } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
             subTotal > this.orderRules.maxValue) {
             this.thresholdCrossed = true;
             this.cartLimitExceed = true;
         } else if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
             const totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
             let details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(
                 this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC
             );
             this.cartLimitExceed = details.cartLimitExceed;
             this.thresholdCrossed = details.thresholdCrossed;
             this.memberCCLimitExceeded = details.monthlyCCValid;
             this.monthlyCCValue = details.monthlyCCValue;
             this.cartLimitNotReach = details.cartLimitNotReach;
         } else {
             this.thresholdCrossed = true;
         }
     }*/

    pickupStockAvailabilityCheck(productIds: number[], pickUpLocationId?: number) {
        const noStockItems: Product[] = [];
        const cartProducts: Product[] = this.products;
        if (pickUpLocationId && pickUpLocationId > 0 && productIds && productIds.length > 0) {
            this._customerService.getProductsByLocation(pickUpLocationId, productIds).subscribe(
                (response: any) => {
                    const posProducts = response;
                    if (posProducts && posProducts.length > 0) {
                        posProducts.forEach((pickUpProduct) => {
                            const cartProduct = cartProducts.find((product) => product.id === pickUpProduct.productId);
                            if (cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity) {
                                cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                                noStockItems.push(cartProduct);
                            }
                        });
                    }
                    this.outOfStockItems = noStockItems;
                    if (this.outOfStockItems && this.outOfStockItems.length > 0) {
                        this.outOfStockModal.open();
                        this.isSubmitted = false;
                    } else {
                        this.submitOrder();
                    }
                },
                (error: any) => {
                    const notification: any = this._translatePipe.get('orderdetails.Sorry, Something Went Wrong: Please try again later.');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            );
        }
    }

    closeOutOfStockForm() {
        this.outOfStockModal.close();
        this.isSubmitted = false;
    }

    submitOrder(url?: string) {
        this.isSubmitted = true;
        if (this.address && !this.address.isSavedAddress && this.orderFormGroup.value.saveForFutureUse) {
            if (!this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
                this.saveAddress(this.getShippingAddress());
            }
        }
        let requestUrl = '';
        this.isSubmitted = true;
        requestUrl = url || ApiUrlConstants.orderApiUrl + '/V1/orders';
        this.submitPlaceOrder(requestUrl);
    }
    /**
     * @description Clear the out of stock items and update the tax
     * @memberof ServiceOrderComponent
     */
    clearOutOfStockItems(): void {
        const items = this.orderFormGroup.get('items') as any;
        if (this.outOfStockItems && this.outOfStockItems.length) {
            const productIds = this.outOfStockItems.map((product: Product) => product.id);
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.isSubmitted = false;
            this.outOfStockModal.close();
        }
    }

    /**
     * @description Remove out of stock items from cart items
     * @param {FormArray} items
     * @param {number[]} productIds
     * @memberof ServiceOrderComponent
     */
    removeOutOfStockItems(items: FormArray, productIds: number[]) {
        productIds.forEach((id: number) => {
            const productIndex = items.value.findIndex((product) => product.productId === id);
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    }

    /**
     * @description this method is used
     * to get selected sponsorinfo from sposor component
     * @memberof PersonalInfoComponent
     */
    getSelectedSponserInfo(sponsorInformation: SponsorInformation): void {
        this.sponsorInformation = sponsorInformation;
    }

    /**
     * @description this method will fire when we chaneg textbox value
     * in address block
     * @memberof PersonalInfoComponent
     */
    getAddressOnInputChange(address: Address): void {
        if (this.formPickupPersonAddressValid) {
            this.pudoAddress = address;
            this.pudoCollectionPoints = null;
            this.selectedPudoCollectionPoint = null;
            this.hidePudoPickupLocationsButton = true;
            this.pudoLocationsNotFound = false;
            if (this.pudoAddress) {
                this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
            }
        }
        if (!this.sponsorInformation) {
            this.liveFormAddress = address;
            this._enrollmentMessageService.setSponsorPreference(this.liveFormAddress);
        }
        if (this.mailingAddress && !this.shippingAddressInfo) {
            this.prepopulateShippingAddress();
        }
    }

    addressChangedByUser(changed: boolean): void {
        this.shippingAddressChanged = changed;
        if (changed) {
            this.selectedPudoCollectionPoint = null;
        }
    }

    /**
     * @description this method will prepopulate shipping address
     * @param {string} sponsorId
     * @memberof ServiceOrderComponent
     */
    prepopulateShippingAddress(): void {
        if (this.appConfig && this.appConfig.skipAddressVerification && this.mailingAddress) {
            this.mailingAddress.addressVerified = true;
        }
        const address: Address = this.mailingAddress;
        if (this.liveFormPersonalInfo) {
            address.firstName = this.liveFormPersonalInfo.firstName;
            address.lastName = this.liveFormPersonalInfo.lastName;
            address.middleName = this.liveFormPersonalInfo.middleName;
            address.email = this.liveFormPersonalInfo.email;
            address.phoneNumber = this.liveFormPersonalInfo.phoneNumber;
        }
        this.address = address;
        this.showAddressForm = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        setTimeout(() => {
            this.address = this.address;
            this.showAddressForm = true;
        }, 500);
    }
    /**
     * @description this method will display order details
     * @param {EnrollInfo} enrollRequest
     * @memberof ServiceOrderComponent
     */
    displayOrderSuccessDetails(retailResponse: EnrollInfo): void {

        if (retailResponse && retailResponse.orderInfo && retailResponse.orderInfo.webOrderId) {
            retailResponse.webOrderId = retailResponse.orderInfo.webOrderId;
            retailResponse.id = retailResponse.orderInfo.id;
            this.createOrderLog(retailResponse);
            this.orderSuccess(retailResponse);
            this.isSubmitted = false;
        }
    }

    /**
     * @description  this method is used to
     * get the verified or sugggested address
     * @param {Address} mailingAddress
     * @memberof PersonalInfoComponent
     */
    getMailingAddressInfo(address: Address): void {
        this.mailingAddress = address;
        this.getAddressOnInputChange(address);
    }

    /**
     * @description
     */
    /*  validateOrderLimit(quantityUpdate: boolean): void {
        if (!this.orderRules) {
            return;
        }
        const exceedMonthlyCCPopup: any = this._translatePipe
            .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
        const exceedMonthlyCCOverridePopup: any = this._translatePipe
            .get('order.Monthly CC limit reached');
        const orderRulesMaxValue = this.orderRules && this.orderRules.maxValue ? this.orderRules.maxValue : this.orderRules.literatureMaxValue;
        const exceedPerOrderCC: any = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.',
            { max: this.storeInfo.currencySymbol + ' ' + ((this._commonService.validateNumberDecimalPoint(orderRulesMaxValue) ? orderRulesMaxValue : orderRulesMaxValue + '.00') || '0') });
        let minimumCartLimit: any = this._translatePipe.get('order.Order must meet a minimum of');
        const maximumCartLimit: any = this._translatePipe.get('order.Cart must not exceed');
        if (this.thresholdCrossed && this.orderRules && this.orderRules.valueType !== ValueType.BOTH) {
            if (this.cartLimitExceed) {
                const cartMaximumLimitNotification: any = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                    this.storeInfo.currencySymbol + this.orderRules.maxValue + '</b>';
                if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberInfo && this.memberInfo.memberTypeId !== MemberTypeEnum.GUEST) {
                    this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
                this.isSubmitted = false;
            } else if (this.cartLimitNotReach && !quantityUpdate) {
                if (this.products && this.products.length &&
                    this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
                    && this.appConfig.displayPurchaseLimitationMessage
                    && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                    minimumCartLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                }
                const cartMinimumLimitNotification: any = minimumCartLimit.value + ' <b class="helvetica-bold">' +
                    this.storeInfo.currencySymbol + this.orderRules.minValue + '</b>';
                this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                this.isSubmitted = false;
            } else {
                this._commonService.removeNotification(Constants.MIN_LIMIT);
                this._commonService.removeNotification(Constants.MAX_EXCEEDED);
            }
        } else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
            this._commonService.removeNotification(Constants.MAX_EXCEEDED);
        }
        if ((this.memberCCLimitExceeded || this.thresholdCrossed) && !this.memberCCOverrideLimitExceeded) {
            const monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                + this.monthlyCCValue + '</b>';
            if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                if (this.memberCCLimitExceeded) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR);
                }
                if ((this.cartLimitExceed || this.cartLimitNotReach) && !quantityUpdate) {
                    let isLiteratureValidation = this.isLiteratureValidation(this.products);
                    let invalidProductPopup: any = this._translatePipe.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}',
                        {
                            min: isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue,
                            max: isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue
                        });
                    this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                } else {
                    this._commonService.removeNotification(Constants.ORDER_LIMIT);
                }
            } else if (!this.appConfig.displayPurchaseLimitationMessage) {
                if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                } else {
                    this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                }
            } else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            }
            this.isSubmitted = false;
        }
        if (this.memberCCOverrideLimitExceeded) {
            this._commonService.createNotification('', exceedMonthlyCCOverridePopup.value, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
            this.isSubmitted = false;
        } else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
        }
    } */

    /**
     * @description place order
     * @param {string} requestUrl
     * @memberof ServiceOrderComponent
     */
    placeOrder(requestUrl: string): void {
        // this.validateOrderLimit(false);
        const currentCC = this.calculateTotalPoints();
        if ((((this.orderRules && !this.thresholdCrossed) || !this.orderRules) && (!this.memberCCOverrideLimitExceeded) &&
            ((this.memberOrderCCInfo && !this.memberCCLimitExceeded) || !this.memberOrderCCInfo))
            || (!currentCC && this.orderRules.valueType !== ValueType.BOTH)
        ) {
            const availableCC = this.existingCC ? this.existingCC - currentCC
                : this.distributorMaxCC - currentCC;
            const memberHomeCountry = this.memberInfo && this.memberInfo.memberAllowedCountries && this.memberInfo.memberAllowedCountries.length
                ? this.memberInfo.memberAllowedCountries.find((country: MemberAllowedCountries) => country.homeCountry === true) : null;
            const isMemberHomeCountry = memberHomeCountry && this.selectedIsoCountryCode === memberHomeCountry.isoCodeThree ? true : false;
            if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER && isMemberHomeCountry &&
                ((availableCC <= 0 || availableCC >= this.distributorMaxCC) || (this.memberInfo.wholeSaleQualified))
                && this.orderFormGroup.controls['paymentSelector'].value !== this.selectEnum.thirdOption.toString()
                && this.appConfig.fpcToFboUpgradeFlowEnable) {
                this.optInCheck = true;


            } else {
                this.submitPlaceOrder(requestUrl);
            }
        }
    }

    /**
     * @description
     * @memberof ServiceOrderComponent
     */
    submitPlaceOrder(requestUrl: string): void {
        const orderRequest: any = this.prepareOrderRequest();
        const compareTaxValues = this.appConfig && this.appConfig.ignoreCompareTax ? true : this.compareTax(orderRequest);
        if (compareTaxValues) {
            this.comparePriceTier(orderRequest, requestUrl);
        } else {
            const notification: any = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }

    }

    /**
     * @description compare tax
     * @param {Order} orderRequest
     * @returns {boolean}
     * @memberof ServiceOrderComponent
     */
    compareTax(orderRequest: Order): boolean {
        if (orderRequest && orderRequest.taxMetaData && orderRequest.taxMetaData.orderTaxCharges
            && orderRequest.taxMetaData.orderTaxCharges.length > 0) {
                let totalTaxAmount = 0;
                orderRequest.taxMetaData.orderTaxCharges.forEach(tax => {
                    totalTaxAmount = totalTaxAmount + parseFloat(tax.taxAmount.toFixed(2));
                });

           totalTaxAmount = this._currencyPipe.getFormatedCurrency(totalTaxAmount, this.storeInfo);
            if (orderRequest.orderTax.toFixed(2) === totalTaxAmount.toFixed(2)) {
                return true;
            } else {
                return false;
            }

        } else {
            return true;
        }
    }
    /**
     * create order log request parameter
     */
    createOrderLog(res) {
        const orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': res.id,
            'webOrderId': res.webOrderId,
            'message': 'Order Placed by the agent',
            'source': Constants.CUSTOMER_SERIVCE
        };
        this._orderService.createOrderLog(orderLogRequest)
            .subscribe((response) => {
            }, (error: any) => {
                this._commonService.createNotification('', 'Failed to Create order log', NotificationType.ERROR);
            });
    }


    private orderSuccess(response: any) {
        this.showSelectedShipMethod = false;
        this.paymentComponentSettings.webOrderId = response.webOrderId;
        this.paymentComponentSettings.orderReferenceId = response.id;
        this.orderFromLookup = false;
        this.hasPersistedMemberId = false;
        this.fboid = '';
        this.messageService.setPersitedMemberId(null);
        this.showShippingData = false;
        this.clearAllTheForms(true, true, true);
        this.isSubmitted = false;
        this.openOrderViewTab(this.paymentComponentSettings.webOrderId);
        this.paymentComponentSettings = new PaymentComponentSettings();
    }

    openOrderViewTab(weborderID: string) {
        const orderInfo = new OrderInfoTab();
        orderInfo.webOrderID = weborderID;
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode;
        orderInfo.newOrder = true;
        this.clearTabStoreSetting();
        this.messageService.setOrderHistoryTab(orderInfo);
    }

    private orderPending(response: any) {
        if ((response.json().status === 'IN-PROGRESS') || (response.json().status === 'QUEUED')) {
            if (this.pollCount < this.maxPollCount) {
                if (localStorage.getItem('appadmin.pollCount')) {
                    this.pollCount = +(localStorage.getItem('appadmin.pollCount'));
                } else {
                    localStorage.setItem('appadmin.pollCount', '1');
                }
                this.pollCount = this.pollCount + 1;
                localStorage.setItem('appadmin.pollCount', this.pollCount + '');
                this.submitOrder(response.json().location);
            }
        } else {
            localStorage.removeItem('appadmin.pollCount');
        }
        localStorage.removeItem('appadmin.pollCount');
    }

    prepareOrderRequest(): any {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);

        let orderTypeId = this.orderType.SERVICE_ORDER;

        const shippingAddress = this.getShippingAddress();
        if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === shippingAddress.countryId);
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status */
        const memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        const shippingObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === this.orderFormGroup.value.shipMethodId)[0];
        const orderRequest: any = {
            backDateOrder: false,
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: OrderStatus.Pending,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            email: this.memberInfo ? this.memberInfo.email : this.personalInformation ? this.personalInformation.email : null,
            languageCode: this.languageShortCode,
            languageCulture: this._commonService.getLanguageCulture(this.storeInfo, this.countryCode, this.memberInfo),
            storeId: this.storeInfo.id,
            orderTypeId: orderTypeId,
            memberLevelId: memberTitleId,
            shippingCost: 0,
            importFeeValue: this.importFeeValue,
            shippingTax: (this.memberShippingDiscountOfferEligible ||
                (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice)) ? 0 : this.shippingTax,
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : null,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: OrderSourceTypes.CUSTOMERSERVICE,
            orderGroupId: this.orderFormGroup.value.orderType === this.orderType.SERVICE_ORDER
                ? this.orderType.REPLACEMENT : 2,
            orderNotes: null,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: this.getOrderPaymentInfo(),

            shippingAddressModel: shippingAddress,
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            loggedInUserId: this.userInfo ? this.userInfo.userId : null,
            loggedInUserName: this.userInfo ? this.userInfo.userName : null,
            taxMetaData: null,
            priceTierName: this.getPriceTier(),
            wholesaleQualified: this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false,
            memberTypeId: this.memberTypeId,
            sponsorId: this.memberInfo ? this.getOrderSponsorId() : this.sponsorInformation
                ? this.sponsorInformation.sponsorId : null,
            personalDiscountPercentage: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage)
                : this.personalDiscountPercentage,
            memberLevelDiscount: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage) : 0,
            // we have to send the wholesale discount percentage of the user,
            // how much discount he will get if he is an wholesaleQualified User
            wholesaleQualifiedDiscount: this.memberInfo ?
                this._commonService.getWholesaleQualifiedDisc(this._orderService
                    .getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId)) : 0,
            optIn: this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            vatID: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.governmentId : null,
            sessionGuid: this.getSessionGuid(),
            accountLevelId: this._commonService.getMemberAccountLevelId(this.memberInfo),
            coldProtection: shippingObj ? shippingObj.coldProtection : false,
            businessEntityId: this.businessEntityId,
            sourceTypeId: 5
        };
        return orderRequest;
    }
    /**
     *  @description thi smethod used for to get t the sponsor id
     *
     */
    getOrderSponsorId(): string {
        if (this.refSponsorId) {
            if (this.isEnableFboReferralId()) {
                return this.sponsorInformation.sponsorId;
            }
            return this.refSponsorId.toString();
        }
    }

    /**
   * @description
   * @memberof CommonService
   */
    getCountryTaxInclusiveInfo(country: Country): boolean {
        let countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    }
    /**
     * @description comapare price tier details for line items
     * @param {*} orderRequest
     * @returns {boolean}
     * @memberof ServiceOrderComponent
     */
    comparePriceTier(orderRequest: any, requestUrl: string): void {
        const memberDetails = this.memberInfo ? this.memberInfo : null;
        if (orderRequest && orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0 && memberDetails) {
            const wholesaleQualified: boolean = memberDetails && memberDetails.wholeSaleQualified
                ? memberDetails.wholeSaleQualified : false;
            const optin: boolean = memberDetails && memberDetails.optin ? memberDetails.optin : false;
            let memberTitleId = memberDetails && memberDetails.memberLevelId
                ? this.memberInfo.memberLevelId : memberDetails && memberDetails.memberTitleId ? memberDetails.memberTitleId : null;
            const memberTypeId = memberDetails && memberDetails.memberTypeId ? memberDetails.memberTypeId : null;
            // HARD_DOWNGRADE CHECK FOR FPC USERS
            memberTitleId = this._orderService.getDowngradeTitleID(memberTypeId, memberTitleId);
            this._orderService.getPriceTierByMemberId(this.storeInfo.id, memberTitleId, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe((response: PriceTierResponse) => {
                if (response) {
                    if (response.priceTireName) {
                        const priceTierName = response.priceTireName;
                        let isPriceTierMatched = true;
                        orderRequest.orderLineItems.forEach(item => {
                            if (priceTierName !== item.priceTierName) {
                                isPriceTierMatched = false;
                            }
                        });
                        this.checkLineItemsPriceTier(isPriceTierMatched, orderRequest, requestUrl);
                    } else {
                        this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
                    }
                }
            }, (error) => {
                this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
            });
        } else {
            this.checkLineItemsPriceTier(true, orderRequest, requestUrl);
        }
    }

    /**
     * @description check line items pricetier
     * @param {boolean} isPlaceOrder
     * @param {*} orderRequest
     * @returns {void}
     * @memberof ServiceOrderComponent
     */
    checkLineItemsPriceTier(isPlaceOrder: boolean, orderRequest: any, requestUrl: string): void {
        if (isPlaceOrder) {
            this.submitOrderBasedOnPriceTierCheck(orderRequest, requestUrl);
        } else {
            if (orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0) {
                const productIds = orderRequest.orderLineItems.map((item: Product) => item.productId);
                if (productIds && productIds.length) {
                    this.orderFormGroup.get('items').reset();
                    const arr = <FormArray>this.orderFormGroup.controls.items;
                    arr.controls = [];
                    this.getProductsByIds(productIds, this.storeInfo);
                    const notification: any = this._translatePipe.get('order.Product prices are updated. please verify and submit order');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            }
        }
    }

    /**
     * @description submit Order
     * @param {*} orderRequest
     * @memberof ServiceOrderComponent
     */
    submitOrderBasedOnPriceTierCheck(orderRequest: any, requestUrl: string): void {

        if (orderRequest) {
            let notification: any;
            this._orderService.createNewOrder(orderRequest, requestUrl).subscribe((response: any) => {
                if (response) {
                    if (response.json().status === 'COMPLETED' && response.json().responseModel
                        && response.json().responseModel.success) {
                        if (this.appConfig && this.appConfig.freeShippingFPCOrder && this.memberShippingDiscountOfferEligible) {
                            this.removeMemberDiscountOffer(this.memberInfo.memberId);
                        }
                        this.orderSuccess(response.json().responseModel);
                        const sessionGuid = ((this.memberCart && this.memberCart.sessionGuid) || this.memberCartSessionGuid);
                        if (sessionGuid && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST && this.shoppingBagClicked) {
                            this.deleteCart(sessionGuid);
                        }
                    } else if (response.json().responseModel && response.json().status === 'VALIDATION-ERROR'
                        && response.json().responseModel.validations.length > 0) {
                        const exceedLimitNotification = response.json().responseModel.validations[0].message;
                        response.json().responseModel.validations.forEach(x => {
                            if (x.message === StatusConstants.MONTHLY_CC_EXCEEDED) {
                                notification = this._translatePipe.get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                                const errorMessage = notification.value + ' <b class="helvetica-bold">'
                                    + (this.memberCCOverride && this.memberCCOverride.cVLimit ? this.memberCCOverride.cVLimit : this.memberOrderCCInfo.maxCCValue) + '</b>';
                                this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
                            } else {
                                notification = this._translatePipe.get('order.Unable to Process the Order');
                                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }
                        });
                    } else {
                        this.orderPending(response);
                    }
                    this.isSubmitted = false;
                }
            }, (error: Response) => {
                this.orderSessionGuid = orderRequest.sessionGuid;
                this.getOrderDetailsByUuid(this.orderSessionGuid, orderRequest.distrubutorId);
            });
        }
    }

    /**
* @returns OrderLineItem
*/
    private getOrderLineItems(countryTaxInclusive: boolean): any[] {
        const lineItems: any[] = [];
        // const items: any = this.orderFormGroup.get('items');
        if (this.products && this.products.length > 0) {
            let itemLineNumber = 0;
            let lineItemTax: any;
            this.products.sort((x, y) => {
                return (x.comboBOMEnabled === y.comboBOMEnabled) ? 0 : x.comboBOMEnabled ? 1 : -1;
            });
            this.products.forEach((product: any) => {
                if (product) {
                    let unitPrice: number = countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    let retailPrice: number = countryTaxInclusive ? product.retailPrice : product.baseRetailPrice;
                    let wholesalePrice: number = countryTaxInclusive ? product.wholesalePrice : product.baseWholesalePrice;
                    if (this.displayPriceConfig) {
                        unitPrice = this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice :
                                (this.displayPriceConfig.displayCatalogPrice ? product.catalogPrice : product.applicablePrice));
                        retailPrice = this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice;
                        wholesalePrice = this.displayPriceConfig.displayWholesalePrice ? product.wholesalePrice :
                            this.displayPriceConfig.displayBaseWholesalePrice ? product.baseWholesalePrice : product.wholesalePrice;
                    }
                    if (this.orderTaxResponse && this.orderTaxResponse.cart && this.orderTaxResponse.cart.orderLineItems
                        && this.orderTaxResponse.cart.orderLineItems.length > 0) {
                        lineItemTax = this.orderTaxResponse.cart.orderLineItems.find(y => y.itemNumber === product.itemNumber);
                    }
                    const unitDiscountPrice = this.memberInfo && this.memberInfo.transactionalWholesaleQualified ?
                        (product.baseWholesalePrice - product.catalogPrice) : 0;
                    const retailUnitPrice = product.retailPrice ? product.retailPrice.toFixed(2) : product.retailPrice;
                    const lineItem: any = {
                        discountPercentage: product.discountPercentage,
                        literature: product.literature,
                        orderLineNumber: ++itemLineNumber,
                        productId: product.id,
                        itemNumber: product.itemNumber,
                        productName: product.displayName ? product.displayName : product.name,
                        unitRetailPrice: retailPrice,
                        unitWholeSalePrice: wholesalePrice,
                        unitBaseWholeSalePrice: product.baseWholesalePrice,
                        unitPaidPrice: unitPrice,
                        taxInclusive: (this.checkoutConfig && this.checkoutConfig.storeTaxExclusivePrice) ? false : countryTaxInclusive,
                        unitTaxExclusiveRetailPrice: product.baseRetailPrice,
                        unitTaxExclusivePaidPrice: product.catalogPrice,
                        unitCommissionablePrice: 0,
                        importedMeasurementUnit: product.importedMeasurementUnit,
                        revisionNumber: product.revisionNumber,
                        taxRate: product.taxRate || 0,
                        unitTax: lineItemTax ? lineItemTax.salesTax : 0,
                        unitTaxablePrice: lineItemTax && lineItemTax.taxablePrice ? lineItemTax.taxablePrice : 0,
                        unitQualificationValue: product.commissionableVolume || 0,
                        quantity: product.quantity,
                        freeshipping: false,
                        shippable: product.shipping ? product.shipping.shippingRequired : null,
                        fboEligible: this.getFBOEigibleProduct(product),
                        downloadActivated: product.downloadableProduct,
                        weight: product.shipping ? product.shipping.weight : null,
                        height: product.shipping ? product.shipping.height : null,
                        length: product.shipping ? product.shipping.length : null,
                        width: product.shipping ? product.shipping.width : null,
                        // totalAmount: this._currencyPipe.getFormatedCurrency(x.applicablePrice * x.quantity),
                        totalAmount: this._currencyPipe.getFormatedCurrency(this.getItemTotalSum(product), this.storeInfo),
                        discountAmount: this._currencyPipe.getFormatedCurrency
                            (this.calculateDiscountAmount(product, this.displayPriceConfig), this.storeInfo),
                        personalDiscount: this._currencyPipe.getFormatedCurrency(((
                            parseFloat(retailUnitPrice) * product.quantity
                            * this.personalDiscountPercentage) / 100), this.storeInfo),
                        priceTierName: product.priceTierName,
                        netUnitPrice: this.appConfig && this.appConfig.calculateNetUnitPrice
                            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
                            && this.memberInfo.transactionalOptin ? this.calculateNetUnitPrice(product) : 0,
                        unitDiscount: unitDiscountPrice,
                        lineDiscount: unitDiscountPrice * product.quantity,
                        comboBOMEnabledProduct: product.display ? (product.display.comboBOMEnabled ? true : false) : false,
                        shippableFulfillment: product.shipping ? (product.shipping.shippableFulfillment ? true : false) : false
                    };
                    lineItems.push(lineItem);
                }

            });
        }
        return lineItems;
    }

    /**
     * @description get FBO eligible product
     * @private
     * @param {Product} product
     * @returns {boolean}
     * @memberof ServiceOrderComponent
     */
    private getFBOEigibleProduct(product: Product): boolean {
        if (product.productMetaData) {
            const fboEligibilty = product.productMetaData.
                find(x => x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE);
            if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                return true;
            }
        }
    }

    private getOrderShippings(): any[] {
        const orderShippings: any[] = [];
        let shippingAddressId = null;
        if (this.savedAddressId) {
            shippingAddressId = this.savedAddressId;
        } else if (this.verifiedShippingAddressId) {
            shippingAddressId = this.verifiedShippingAddressId;
        }
        const discountPercentage = this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
            && this.orderFormGroup.controls['shippingCostPercentage'].value > 0
            ? this.orderFormGroup.controls['shippingCostPercentage'].value : 0;
        const orderShipping: any = {
            deliveryPreferenceId: this.orderFormGroup.value.deliveryPreference,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingAddressId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) ?
                shippingAddressId : null,
            shortCode: this.shipMethod != null ? this.shipMethod.shortCode : null,
            preferredTime: null,
            notes: null,
            shipmentDate: null,
            shippingWaived: false,
            // shippingWaived: this.memberShippingDiscountOfferEligible ? true :
            //     ((+this.orginalShippingCost) - (+this.getOrderShippingCost())) === 0 ? false : true,
            shippingWaiverPercentage: this.memberShippingDiscountOfferEligible ? 100 :
                discountPercentage > 0 ? discountPercentage : null,
            distributionCenter: this.shipMethod != null ? this.shipMethods.distributionCenterName : null
        };

        if (orderShipping.deliveryPreferenceId === ShippingType.PICKUP) {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && !this.isPickUpOptionExist) {
                orderShipping.distributionCenter = (this.pudoShippingMethod.pickUpLocation.pickupCenterName) ? this.pudoShippingMethod.pickUpLocation.pickupCenterName : '';
            } else {
                orderShipping.distributionCenter = (this.shipMethod.pickUpLocation.pickupCenterName) ? this.shipMethod.pickUpLocation.pickupCenterName : '';
            }
        }
        orderShippings.push(orderShipping);
        return orderShippings;
    }

    getAddresses(): any {
        const addresses: any[] = [];
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            const pickupAddress = this.getPickUpAddress();
            if (pickupAddress) {
                pickupAddress.deliveryInstruction = pickupAddress && pickupAddress.instruction ? pickupAddress.instruction : '';
                pickupAddress.email = pickupAddress.email ? pickupAddress.email : null;
                addresses.push(pickupAddress);
            }

        } else {
            const addrss = this.getShippingAddress();
            if (addrss && !(this.orderFormGroup.value.deliveryPreference == DeliveryPreference.DROPSHIP)) {
                addresses.push(addrss);
            }

        }
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            const pudoPickUpAddress = this.getPudoPickUpAddress(this.pudoShippingAddressInfo, this.pudoShippingMethod);
            pudoPickUpAddress.deliveryInstruction = pudoPickUpAddress && pudoPickUpAddress.instruction ? pudoPickUpAddress.instruction : '';
            pudoPickUpAddress.email = pudoPickUpAddress.email ? pudoPickUpAddress.email : null;
            addresses.push(pudoPickUpAddress);
            if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled)) {
                if (this.pudoShippingAddressInfo) {
                    addresses.push(this.getShippingAddress(this.pudoShippingAddressInfo));
                }

            }
        }
        if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) {
            addresses.push(this.getBillingAddress());
        }
        return addresses;
    }

    calculateOrderTotal(): number {
        let totalCost = 0;
        if (this.storeInfo) {
            // tslint:disable-next-line:no-bitwise
            totalCost = Number(totalCost.toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
        }
        return totalCost;
    }



    /**
   * @param  {any} shippingInfo
   * @returns void
   */
    calculateOrderTax(): void {
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.gstTax = 0;
        this.pstTax = 0;
    }

    getTaxablePrice(taxablePrice: number, item: any): number {
        const enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.selectedIsoCountryCode);
        if (this.appConfig && this.appConfig.calculateNetUnitPrice
            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
            && this.memberInfo.transactionalOptin &&
            (this.memberInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                && enableWHLSAL00ForAsstSupervisor)) {
            return this.calculateNetUnitPrice(item);
        } else if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
            && !enableWHLSAL00ForAsstSupervisor) {
            return item.catalogPrice;
        } else {
            return taxablePrice;
        }

    }

    getPriceTier() {
        let priceTierName = '';
        if (this.products && this.products.length > 0) {
            priceTierName = this.products[0].priceTierName;
        }
        return priceTierName;
    }

    addNewProductItem(items, index, product) {
        const itemValue = product.itemNumber + ' - ' + product.name;
        items.controls[index].controls['itemNumber'].setValue(itemValue);
        const itemImage = (product.imageModelList && product.imageModelList.length > 0)
            ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
        const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
            : (environment.uiTemplateBaseUrl + '/images/no_image.png');
        items.controls[index].controls['productImage'].setValue(imageUrl);
        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
        items.controls[index].controls['productId'].setValue(product.id);
        items.controls[index].controls['productItem'].setValue(product);
        items.controls[index].controls['disableIncrement'].setValue(false);
        return items;
    }

    setFocusbyID(id) {
        setTimeout(() => {
            const element = document.getElementById(id) as HTMLInputElement;
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    }
    moveToItemLevelSearchBlock(event: any) {
        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
            this.itemLevelSearch.nativeElement.focus();
        }
    }

    /**
     * @description item number search in table
     * @param {*} event
     * @memberof ServiceOrderComponent
     */
    itemLevelSearchEvent(event: any) {
        if (event.currentTarget.value) {
            this.taxCalculationStatus = true;
            this.observableSource(event.currentTarget.value, true).subscribe((products) => {
                const responseproducts = products;
                if (responseproducts.length > 0) {
                    const product = responseproducts[0];
                    const isStockAvailable = this.stockAvailable(product);
                    if (isStockAvailable) {
                        let items: any = this.orderFormGroup.get('items');
                        if (items && items.length >= 0) {
                            const sameProductIndex = items.controls.findIndex(item =>
                                item.controls['productNumber'].value === product.itemNumber);
                            if (sameProductIndex >= 0) {
                                items.controls[sameProductIndex].controls['quantity']
                                    .setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                                this.setFocusbyID('quantity-' + (sameProductIndex));
                            } else {
                                this.addItemNumber();
                                const index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(1);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                items = this.addNewProductItem(items, index, product);
                                this.setFocusbyID('quantity-' + (items.length - 1));
                            }
                        }
                        this.updateTotalsAndShipMethod();
                        if (this.orderFormGroup.controls['orderType'].value === OrderType.POS
                            || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                            this.deliveryPreferenceOnChange();
                        }
                    } else {
                        this._commonService.createNotification('', 'Out of stock - '
                            + (product.name || ''), NotificationType.ERROR);
                        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                            this.itemLevelSearch.nativeElement.focus();
                        }
                        this.taxCalculationStatus = false;
                    }
                } else {
                    if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                        this.itemLevelSearch.nativeElement.focus();
                    }
                    const notification: any = this._translatePipe.get('order.Invalid Item Number');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
                this.itemLevelSearch.nativeElement.value = '';
            });
        }
    }

    /**
     * @description Check stock available or not
     * @param {Product} product
     * @returns {boolean}
     * @memberof ServiceOrderComponent
     */
    stockAvailable(product: Product): boolean {
        return (product.manageStock && product.stockQuantity > 0) || (product.stockAvailable && !product.manageStock);
    }
    /**
     * @description auto complete search
     * @memberof ServiceOrderComponent
     */
    onItemSelect() {
        const searchProduct = this.orderFormGroup.controls['itemSearch'].value;
        if (searchProduct && searchProduct.id) {
            const isStockAvailable = this.stockAvailable(searchProduct);
            if (isStockAvailable) {
                let items: any = this.orderFormGroup.get('items');
                if (items && items.length >= 0) {
                    this.taxCalculationStatus = true;
                    const sameProductIndex = items.controls.findIndex(item => item.controls['productNumber'].value === this.orderFormGroup.controls['itemSearch'].value.itemNumber);
                    if (sameProductIndex >= 0) {
                        items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                        this.orderFormGroup.controls['itemSearch'].setValue('');
                        this.setFocusbyID('quantity-' + (sameProductIndex));
                    } else {
                        this.addItemNumber();
                        const index = (items.length - 1);
                        items.controls[index].controls['quantity'].setValidators([Validators.required]);
                        if (!items.controls[index].controls['quantity'].value) {
                            items.controls[index].controls['quantity'].setValue(1);
                            // this.getShipMethods();
                        }
                        items.controls[index].controls['quantity'].updateValueAndValidity();
                        if (this.orderFormGroup.controls['itemSearch'].value) {
                            const typHeadItem = this.orderFormGroup.controls['itemSearch'].value;
                            this.orderFormGroup.controls['itemSearch'].setValue('');
                            items = this.addNewProductItem(items, index, typHeadItem);
                        }
                        this.updateTotalsAndShipMethod();
                        this.isFocused = true;
                        this.setFocusbyID('quantity-' + (items.length - 1));
                    }
                }
                if (this.orderFormGroup.controls['orderType'].value === OrderType.POS
                    || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                    this.deliveryPreferenceOnChange();
                }
            } else {
                this._commonService.createNotification('', 'Out of stock - '
                    + (this.orderFormGroup.controls['itemSearch'].value.name || ''), NotificationType.ERROR);
                this.orderFormGroup.controls['itemSearch'].setValue('');
                setTimeout(() => {
                    if (this.seachItemElement && this.seachItemElement.nativeElement) {
                        this.seachItemElement.nativeElement.focus();
                    }
                }, 500);
            }
        }
    }

    shippingAddressSelectionChange() {
        this.shippingAddressInfo = this.address ? this.address : null;
        this.address = this.address && this.address.isSavedAddress ? this.address : null;
        this.getShipMethods();

    }
    allowOnlyNumbers(event: any) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            const value: any = (event.key ? event.key : '');
            const pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }

    /**
     * Save Shipping Address
     */
    saveShippingAddress(address: Address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        } else if (this.address && this.address.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === address.countryId);
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.verifyAddressButtonClicked = true;
        this.useNewShippingAddress(address);

        setTimeout(function () {
            const addtoSavedAddressesElement = document.getElementById('addtoSavedAddresses');
            if (addtoSavedAddressesElement) {
                addtoSavedAddressesElement.focus();
            }
        }, 200);
    }

    savePudoShippingAddress(address: Address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        } else if (this.pudoAddress && this.pudoAddress.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === address.countryId);
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.pudoShippingAddressInfo = address;
        this.pudoAddress = address;
        this.pudoAddressSubmitted = true;
        this.createOrder();
    }

    showVerifyAddressMessage(): void {
        const verifyAddressError: any = this._translatePipe.get('order.Shipping Address must be verified. Please click on VERIFY ADDRESS');
        this._commonService.createNotification('', verifyAddressError.value, NotificationType.ERROR);
    }
    showPermissionErrorMessage(countryName): void {
        const verifyPermissionError: any = this._translatePipe.get('order.Country dont have service order permission.');
        const permissionError = '<b class="helvetica-bold">' + countryName + '</b> &nbsp;' + verifyPermissionError.value;
        this._commonService.createNotification('', permissionError, NotificationType.ERROR);
    }

    /**
     *load procducts from session
     */
    loadproductsFromSession() {
        this.orderSession.products.forEach((product: any) => {
            this.addItemNumber();
            const items: any = this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                const index = (items.length - 1);
                if (product) {
                    const itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    const itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
                    const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['quantity'].setValue(product.quantity);
                }
            }
        });
        this.updateTotalsAndShipMethod();
    }
    /**
     * map shipping Info with the shipping form
     */
    mapShippingAddressToShippingInfo() {
        const formAddress = this.orderSession.shippingAddressForm;
        const shippingAddressForm: any = this.orderFormGroup.get('shippingAddressForm');
        shippingAddressForm.controls[0].controls['name'].setValue(formAddress.name);
        shippingAddressForm.controls[0].controls['addressLine1'].setValue(formAddress.addressLine1);
        shippingAddressForm.controls[0].controls['addressLine2'].setValue(formAddress.addressLine2 || '');
        shippingAddressForm.controls[0].controls['addressLine3'].setValue(formAddress.addressLine3 || '');
        shippingAddressForm.controls[0].controls['addressLine4'].setValue(formAddress.addressLine4 || '');
        shippingAddressForm.controls[0].controls['city'].setValue(formAddress.city);
        shippingAddressForm.controls[0].controls['stateId'].setValue(formAddress.stateId);
        shippingAddressForm.controls[0].controls['countryId'].setValue(formAddress.countryId);
        shippingAddressForm.controls[0].controls['postalCode'].setValue(formAddress.postalCode);
        shippingAddressForm.controls[0].controls['phone'].setValue(formAddress.phone || '');
        shippingAddressForm.comtrols[0].controls['email'].setValue(formAddress.email || '');
        if (this.orderSession.shipVerificationProcessDone) {
            this.shippingAddressInfo = this.orderSession.shippingAddressInfo;
        }
    }


    /**
* @returns any
*/
    private getOrderPaymentInfo(): any[] {
        const payments: any[] = [];
        let paymentMethodType: string;
        paymentMethodType = (this.storePaymentInfo && this.storePaymentInfo.paymentMethodName) ? this.storePaymentInfo.paymentMethodName : PaymentMethodTypes.Service_Order;
        const orderPayment: any = {
            savePaymentMethod: false,
            paymentAmount: this.calculateOrderTotal(),
            redirect: false,
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
            memberPaymentMethodId: PaymentType.Service_Order,
            creditCardModel: {
                currencyCode: this.storeInfo.currencyCode,
                paymentToken: null,
                paymentMethodType: paymentMethodType,
                maskedCreditCardNumber: null,
                cardHolderName: null,
                expMonth: null,
                expYear: null,
            },
            paymentECheck: null
        };
        payments.push(orderPayment);
        return payments;
    }

    /**
         * get controls of items
         */
    getItemsControl() {
        return <FormArray>this.orderFormGroup.get('items');
    }
    /**
     * prevent +, -, e entering in shipping cost
     */

    keyEventShippingCost(event: any) {
        if (event.keyCode === 43 || event.keyCode === 45 || event.keyCode === 101) {
            event.preventDefault();
        }
    }
    /**
     * On paste event for member Info
     */
    onPasteEvent() {
        setTimeout(() => {
            this.orderFormGroup.controls['memberInfo'].setValue(this.orderFormGroup.controls['memberInfo'].value.trim());
        }, 0);
    }

    /**
   * clear form...
   */
    clearOrderForm(isClearRetailForm?: boolean) {
        this.clearAllTheForms(true, true, true);
        const memberInfoElement = document.getElementById('memberInfo');
        if (memberInfoElement) {
            memberInfoElement.focus();
        }
        this.refSponsorId = null;
        if (this.orderFromLookup) {
            this.getDistributorInfo();
        }
    }


    /**
     * get restricted products
     */
    getRestrictedProducts(productModels: RestrictedProduct[]) {
        this.getShippingRestrictionError();
        this.restrictedProducts = [];
        productModels.forEach((product: RestrictedProduct) => {
            const itemNumber = product.itemNumber.substring(product.itemNumber.indexOf('#') + 1);
            const item = this.products.find((productItem: any) => productItem.itemNumber === itemNumber);
            if (item) {
                this.restrictedProducts.push(item.name + ' - #' + itemNumber);
            }
        });
        this.showRestrictedProducts.open();
    }

    /**
         * @description To Show Shipping Restriction Error message
         * @private
         * @returns {string}
         * @memberof OrderEditComponent
         */
    private getShippingRestrictionError(): string {
        if (this.shippingAddressInfo
            && this.shippingAddressInfo.stateCode && this.shippingAddressInfo.countryId && this.states && this.states.length > 0) {
            const stateName: string = this.states.find(x => x.stateCode === this.shippingAddressInfo.stateCode).stateName;
            const error: any = this._translatePipe.get('order.' + Translations.SHIPPING_RESTRICTION_ERROR, { stateName: stateName });
            this.productErrorMsg = error.value;
        } else {
            const error: any = this._translatePipe.get('order.Following products are not allowed for selected shipping address.');
            this.productErrorMsg = error.value;
        }
        return this.productErrorMsg;
    }

    /**
     * @description sip to different address click
     * @memberof ServiceOrderComponent
     */
    shipToDifferentAddress(): void {
        this.showSavedAddress = true;
        this.isNewCard = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showPudoPickupPersonAddressForm = false;
        }
        setTimeout(() => {
            if (this.memberAddressDetails && this.memberAddressDetails.length > 0) {
                if (this.savedAddressElement && this.savedAddressElement.nativeElement) {
                    this.savedAddressElement.nativeElement.focus();
                }
            } else {
                if (this.addNewAddressEle && this.addNewAddressEle.nativeElement) {
                    this.addNewAddressEle.nativeElement.focus();
                }
            }
        }, 500);
        this.clearPudoLocationSearchData();
    }

    /**
     * @description this method will show new address form
     * @memberof ServiceOrderComponent
     */
    addNewAddress(): void {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayPudoAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewPudoShippingAddress();
        } else if (this.shippingAddressInfoConfig && (!this.shippingAddressInfoConfig.pudoLocationsEnabled && this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayDropAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewDropshipPersonAddress();
        }
        else {
            this.address = null;
            this.showSavedAddress = false;
            this.isNewCard = true;
            this.shippingAddressInfo = null;
            this.shippingMethods = [];
            this.updateTotalsAndShipMethod();
        }
        this.clearPudoLocationSearchData();
    }

    /**
    * @description this method will show new pudo address form
    * @memberof ServiceOrderComponent
    */
    addNewPudoShippingAddress(): void {
        this.pudoAddress = null;
        this.showSavedAddress = false;
        this.showPudoPickupPersonAddressForm = true;
        setTimeout(() => {
            this.displayPudoAddress = true;
        }, 100);
    }

    addNewDropshipPersonAddress(): void{
        this.showDropShipPersonAddressForm = true;
        this.pudoShippingAddressInfo= null;
        setTimeout(() => {
            this.displayDropAddress = true;
        }, 100);
    }

    clearPudoLocationSearchForm() {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = false;
        this.buildPudoLocationSearchForm();
    }
    clearPudoLocationSearchData() {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = true;
        this.buildPudoLocationSearchForm();
    }
    getAddressIsValid(isValid) {
        this.formPickupPersonAddressValid = isValid;
        this.pudoLocationsNotFound = false;
    }


    // getPaymentMethod by Store
    getPaymentMethodsByStore(memberTypeId?: number) {
        let fpc5PercentEnabled: boolean = false;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode,
            this.storeDefaultLanguage ? this.storeDefaultLanguage : this.languageCode,
            this.memberInfo ? this.memberInfo.memberTypeId : memberTypeId,
            this.memberInfo ? this.memberInfo.wholeSaleQualified : null, fpc5PercentEnabled, false, true).subscribe(response => {
                if (response) {
                    this.storePaymentInfo = response;
                    this.storePaymentInfo.forEach(
                        paymentMethod => {
                            if (paymentMethod.paymentMethodId === PaymentType.Service_Order) {
                                this.service_Order_show = true;
                            }
                        });
                    this.savePaymentMethod = this.orderSession && this.orderSession.savePaymentMethod ?
                        this.orderSession.savePaymentMethod : false;
                }

            });
    }

    /**
   * @description get Order Min Max Business Rules
   * @memberof ServiceOrderComponent
   */
    getOrderRules(storeInfo?: StoreConfig): void {
        const userInfo: Member = this.memberInfo;
        let isFboUpgradeFlow = false;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
            isFboUpgradeFlow = (+this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR &&
                this.appConfig && this.appConfig.displayPurchaseLimitationMessage);
        }
        const orderRulesRequest: OrderRulesRequest = {
            countryCode: this.selectedIsoCountryCode,
            memberTitleId: userInfo ? userInfo.memberTitleId : MemberLevel.RETAIL,
            orderType: userInfo && userInfo.memberTitleId !== MemberLevel.RETAIL ? MemberOrderType.Personal
                : MemberOrderType.Retail
        };

        if (!isFboUpgradeFlow) {
            this.getBusinessOrderRules(orderRulesRequest);
        }

        this._orderService.getMemberOrderRestrictionsInfo(userInfo, this.selectedIsoCountryCode)
            .subscribe((response: any) => {
                if (response) {
                    this.restrictedDays = response.restrictedDays;
                    this.getMemberRankLevelHistory(orderRulesRequest, storeInfo, userInfo, isFboUpgradeFlow);
                }
            }, error => {
            });
        if (userInfo && userInfo.memberId && userInfo.memberTitleId !== MemberLevel.RETAIL) {
            if (!isFboUpgradeFlow) {
                this.getMemberOrderRules(userInfo, false);
            }
            this.getMemberCCOverrides(userInfo.memberId);
        }
    }

    getBusinessOrderRules(orderRulesRequest, userInfo?: Member, isFboUpgradeFlow?: boolean): void {
        this._orderService.getOrderBusinessRules(orderRulesRequest)
            .subscribe((response: any) => {
                if (response) {
                    this.orderRules = response;
                    if (isFboUpgradeFlow) {
                        this.getMemberOrderRules(userInfo, false, null, true);
                    }
                }
            }, error => {
            });
    }
    /**
     * To get the order details based on original order
     */
    getOrderDetails(storeInfo: any) {
        if (this.webOrderId) {
            this._orderservice.getRecentOrderInformation(this.webOrderId).subscribe(response => {
                if (response) {
                    this.originalOrderDetail = response;
                    this.setPrepopulateAddress(response);
                    this.refSponsorId = response.sponsorId;
                    this.constructSchemaFormUrl(this.countryCode);
                    this.getClonedOrderDeliveryPreference();
                    const productIds = response.orderLineItems.map(x => x.productId);
                    this.memberInfo.optin = response.optIn;
                    this.getProductsByIds(productIds, storeInfo);
                    this.cloneOrderShipMethodId = this.originalOrderDetail.orderShippings[0].shipMethodId;

                }
            }, (err: any) => {
            });
        }
    }
    setPrepopulateAddress(address: any) {
        this.address = address.addresses[0];
        this.pudoAddress = address.addresses[0];
        this.pickupShipppingMethodName = address.addresses[0].name;
        if (address.addresses[0].email === null) {
            if (address.addresses[1]) {
                this.address.email = address.addresses[1].email;
                this.pudoAddress.email = address.addresses[1].email;
            }
        }
        if (address.addresses[0].phone === null) {
            if (address.addresses[1]) {
                this.address.email = address.addresses[1].email;
                this.pudoAddress.email = address.addresses[1].email;
            }
        }
        if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            address.addresses.forEach(userAddress => {
                if (userAddress.addressType == AddressType.PICKUP_PERSON) {
                    this.pudoShippingAddressInfo = userAddress;
                    this.pudoAddress = this.pudoShippingAddressInfo;
                } else if (userAddress.addressType == AddressType.PUDO) {
                    this.selectedPudoCollectionPoint = userAddress
                }
            });
            this.buildPudoLocationSearchForm(this.pudoShippingAddressInfo.postalCode, this.pudoShippingAddressInfo.city, this.pudoShippingAddressInfo.addressLine1, this.pudoShippingAddressInfo.country, this.originalOrderDetail.orderShippings[0].pudoExternalId);
            this.getPudoLocations();
        }
    }

    getClonedOrderDeliveryPreference() {
        if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DROPSHIP && !this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
            this.showSavedAddress = false;
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.DROPSHIP)
        } else if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.DROPSHIP)

        } else if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.PICKUP) {
            this.displayPudoAddress = true;
            this.showSavedAddress = false;
            this.showPudoPickupPersonAddressForm = true;
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.PICKUP)
        }
        else if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DELIVERY) {
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.DELIVERY)
        }

    }

    /**
     * Get member cc overrides
     * @param memberId
    */
    getMemberCCOverrides(memberId: number): void {
        this._customerService.getMemberCCOverride(this.storeId, memberId)
            .subscribe(response => {
                if (response && response.length) {
                    this.memberCCOverride = response[0];
                }
            }, (err: any) => {
            });
    }

    /** get Member Order rules
     * @description
     * @memberof ServiceOrderComponent
     */
    getMemberOrderRules(userInfo: Member, isBackOrderDate: boolean, requestUrl?: string, isFboUpgradeFlow?: boolean): void {
        this.memberOrderCCInfo = null;
        let fromDate;
        let toDate;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        }
        if (isFboUpgradeFlow) {
            fromDate = this.memberInfo.enrolmentDate.substr(0, 10);
            const enrollDate = new Date(fromDate);
            const orderToDateStr = enrollDate.setDate(enrollDate.getDate() + this.restrictedDays);
            toDate = moment(orderToDateStr).format(DateConstants.DOBFormat);
        }
        this._orderService.getMemberOrderBusinessRules(userInfo.memberId, this.storeId, isBackOrderDate,
            this.selectedIsoCountryCode, userInfo.memberTitleId, null, fromDate, toDate)
            .subscribe((response: any) => {
                if (response) {
                    const memberOrderRules = response;
                    const frequencyType = this.isMemberFboUpgraded ? Constants.FREQUENCY_ABSOLUTE : Constants.FREQUENCY_MONTHLY;
                    this.memberOrderCCInfo = memberOrderRules.memberOrderCCInfo.filter((x: any) => x.frequency === frequencyType)[0];
                    const validateOrderRule = this.verifyOrderRules(isBackOrderDate);
                    this.upgradeFboLimitExceeded = frequencyType === Constants.FREQUENCY_ABSOLUTE ?
                        validateOrderRule.purchaseLimitExceed : false;
                    this.thresholdCrossed = validateOrderRule.thresholdCrossed;
                    this.memberCCLimitExceeded = validateOrderRule.monthlyCCValid;
                    this.monthlyCCValue = validateOrderRule.monthlyCCValue;
                    this.memberCCOverrideLimitExceeded = validateOrderRule.memberCCOverride;
                    this.cartLimitExceed = validateOrderRule.cartLimitExceed;
                    this.cartLimitNotReach = validateOrderRule.cartLimitNotReach;
                    if (requestUrl) {
                        this.placeOrder(requestUrl);
                    }
                }
            }, error => {
            });
    }

    /**
     * @description savePayment methos
     * @memberof ServiceOrderComponent
     */
    savePaymentMethodClicked(savePaymentMethod: boolean): void {
        this.savePaymentMethod = !savePaymentMethod;
    }

    gotoCheckout(): void {
        if (this.shoppingCartCount) {
            if (!this.memberCart) {
                if (this.memberCartInfo.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCartInfo,
                        shoppingBagClicked: true
                    });
                }
            }
            else {
                if (this.memberCart.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCart,
                        shoppingBagClicked: true
                    });
                }
            }
        }
    }

    /**
     * @description
     * @private
     * @memberof ServiceOrderComponent
     */
    private getParticipatingCountries(countryCode: string): void {
        this._customerService.getParticipatingCountries(countryCode)
            .subscribe(response => {
                if (response && response.length > 0) {
                    const participatingCountries = response;
                    const selectedCountryID = participatingCountries.map(item => item.countryId).join(',');
                    this.getMemberAddressByMemberId(this.memberInfo.memberId, selectedCountryID);
                }
            });
    }

    /**
     * check member has access to place an order
     */
    checkMemberAccess() {
        if (this.memberInfo && this.orderFormGroup && this.orderFormGroup.value.orderType === this.orderType.REGULAR
            && this.restrictedDays > 0) {
            let enrollmentDate: Date;
            enrollmentDate = this.memberInfo.enrolmentDate ? new Date(this.memberInfo.enrolmentDate) : new Date(this.memberInfo.createdDate);
            enrollmentDate.setHours(0, 0, 0, 0);
            enrollmentDate.setDate(enrollmentDate.getDate() + this.restrictedDays);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            if (this.isFBOValidationPending) {
                return;
            }
            if (this.upgradeFboLimitExceeded && this.isMemberFboUpgraded) {
                this.displayPurchaseLimitMessage(enrollmentDate);
                this.isMemberHasAccessToOrder = this.calculateItemsSubTotal(this.storeInfo) > 0 ? true : false;
                return;
            } else if (this.isMemberFboUpgraded) {
                this.isMemberHasAccessToOrder = true;
                this._commonService.removeNotification(Constants.PURCHASE_WINDOW);
            } else if (enrollmentDate.getTime() > currentDate.getTime() && this.memberInfo.fboId && !this.isMemberFboUpgraded  ) {
                let restrictPlacingOrder = true;
                if((this.memberInfo.sponsorTransactionalSourceId == transactional.SPNC && this.countryCode && !environment.skipOrderRestrictionCountriesOnSPNCTransaction.includes(this.countryCode.toUpperCase()))){
                    restrictPlacingOrder = false;
                }
                if(restrictPlacingOrder){
                    const nextOrderDate = moment(enrollmentDate).format(DateConstants.DateFormat);
                    const orderPlacingError: any = this._translatePipe.get('order.Next Order is permitted after');
                    this._commonService.createNotification('', orderPlacingError.value + nextOrderDate, NotificationType.ERROR);
                    this.isMemberHasAccessToOrder = false;
                }
            }
        }
    }

    displayPurchaseLimitMessage(enrollmentDate): void {
        let purchaseLimitExceedMessage = this._translatePipe
            .get('order.Orders should not exceed an aggregate of ||maxValue|| until ||endDate||')['value'];
        const nextOrderEligibleDate = moment(enrollmentDate).format(DateConstants.DateFormat);
        let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue,this.storeInfo);
        purchaseLimitExceedMessage = this._translateKey.transform(purchaseLimitExceedMessage,
            {
                maxValue: maxValue,
                endDate: nextOrderEligibleDate
            });
        this._commonService.createNotification('', purchaseLimitExceedMessage, NotificationType.ERROR, 0, Constants.PURCHASE_WINDOW);
    }

    /**
    *
    * @param items
    */
    getItemVolumeSum(): number {
        const taxAmount = 0;
        return taxAmount;
    }
    trackByItem(index: number): number {
        return index;
    }

    /**
    * @description this method used for allow user to enter address fields
    * @memberof PersonalInfoComponent
    */
    enableAddressFields(block: string): void {
        const addressFieldInfo: AddressVisibility = {
            isEnableAddressFields: true,
            block: block
        };
        this.messageService.setEnableAddressFields(addressFieldInfo);
    }

    validateSubTotalBasedOnType(products: any[], subTotal?: any): boolean {
        let isThresholdCrossed = true;
        let itemSubTotal = subTotal;
        let orderMinValue = this.orderRules.minValue;
        let orderMaxValue = this.orderRules.maxValue;
        if (this.isLiteratureValidation(products)) {
            orderMinValue = this.orderRules.literatureMinValue;
            orderMaxValue = this.orderRules.literatureMaxValue;
        }
        if (itemSubTotal >= orderMinValue && itemSubTotal <= orderMaxValue) {
            isThresholdCrossed = false;
        }
        return isThresholdCrossed;
    }

    isLiteratureValidation(products?: any): boolean {
        let literatureItems = this.getLiteratureItems(products);
        let isLiterature = literatureItems && literatureItems.length && products && products.length
            && products.length === literatureItems.length;
        return isLiterature;
    }

    /**
*
* @param items
*/
    getItemTotalSum(item): number {
        return this.calculateSubTotal(this.storeInfo,
            this.countryTaxInclusive, item, this.memberInfo, true);
    }

    /**
      * Get Total CartItems Cost.
      */
    calculateSubTotal(store: StoreConfig, taxInclusiveShippingCountry: boolean,
        item: any, userInfo: Member, taxCalculated: boolean): number {
        let subTotal = 0;
        if (item) {
            const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            if (userInfo && store && store.taxInclusive && isEnableVATCalculation) {
                subTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(item,
                    store, taxInclusiveShippingCountry, userInfo, taxCalculated);
            } else {
                subTotal += this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry,
                    isCalculateTaxExclusivePrice);
            }
        }
        if (store) {
            // tslint:disable-next-line:no-bitwise
            subTotal = Number(subTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return subTotal;
    }

    /**
     * calculate subtotal for vat and not vat registered user
     * calculateSubtotalForVatAndNonVatRegisteredUser()
     */
    calculateSubtotalForVatAndNonVatRegisteredUser(item: any, store: StoreConfig, taxInclusiveShippingCountry: boolean,
        userInfo: Member, taxCalculated: boolean): number {
        if (!item.literature && (taxCalculated || !userInfo.vatRegistered)) {
            if (userInfo.transactionalOptin &&
                userInfo.transactionalWholesaleQualified
                && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                    || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                        && this._commonService.isWHLSAL00enabledForAsstSupervisor(store.homeIsocodeThree)))) {
                const total = Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'computedTaxInclusivePrice']);
                return (Math.round((total + Number.EPSILON) * 100) / 100) * item.quantity;
            } else {
                return Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'applicablePrice'].
                    // tslint:disable-next-line:no-bitwise
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
            }
        } else if (taxCalculated && (userInfo.vatRegistered)) {
            return Number(item.catalogPrice ? item.catalogPrice.
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2))) : item.catalogPrice) * item.quantity;
        } else {
            return this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry);
        }
    }

    /**
    * calculate subtotal
    * calculateItemSubtotal()
    */
    calculateItemSubtotal(item: any, store: StoreConfig, taxInclusiveShippingCountry: boolean, isCalcTaxExclusivePrice?: boolean): number {
        return Number(item[(taxInclusiveShippingCountry === false || isCalcTaxExclusivePrice) ? 'catalogPrice' : 'applicablePrice'].
            // tslint:disable-next-line:no-bitwise
            toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
    }

    /**
     *
     */
    calculateDiscountAmount(item: any, displayPriceConfig: DisplayPriceConfig): number {
        let discountAmount = 0;
        discountAmount = (parseFloat(item.baseRetailPrice ? item.baseRetailPrice.toFixed(2) : item.baseRetailPrice) * item.quantity) -
            (parseFloat(item.catalogPrice ? item.catalogPrice.toFixed(2) : item.catalogPrice) * item.quantity);
        return discountAmount;
    }

    /**
  * Get Total CartItems Cost.
  */
    calculateItemsSubTotal(store: StoreConfig): number {
        let itemsSubTotal = 0;
        if (store) {
            // tslint:disable-next-line:no-bitwise
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return itemsSubTotal;
    }

    /**
       * get member shipping discount offer
       */
    getMemberShippingDiscountOffer(memberId: number): void {
        this._commonService.getMemberShippingDiscountOffer(memberId, this.countryCode).subscribe((response: any) => {
            if (response && response.effectiveEndDate) {
                const currentDate = new Date().setHours(0, 0, 0, 0);
                const endDate = new Date(response.effectiveEndDate.split('T')[0]).setHours(0, 0, 0, 0);
                this.memberShippingDiscountOfferEligible = currentDate <= endDate ? true : false;
            } else {
                this.memberShippingDiscountOfferEligible = false;
            }
        });
    }

    /**
    * @description this method will remove member discount offer for UK FPC second order
    * @memberof OrderSummaryNewComponent
    */
    removeMemberDiscountOffer(memberId: number): void {
        this._commonService.removeMemberDiscountOffer(memberId)
            .subscribe((response: any) => {
            });
    }

    calculateNetUnitPrice(product: any): number {
        const netUnitPrice = product.computedTaxInclusivePrice / (1 + (product.taxRate / 100));
        return Math.round((netUnitPrice + Number.EPSILON) * 100) / 100;
    }

    /**
    * @description this method will calculate shipping cost that has to be used for calculating order summary
    * @memberof ServiceOrderComponent
    */
    getShippingCostForOrderSummary(): number {
        let shippingCost = 0;
        return shippingCost;
    }



    /**
    * @description this method will calculate total shipping cost that includes taxes
    * @memberof ServiceOrderComponent
    */
    getOrderShippingCost(): number {
        return ((this.memberInfo && this.memberInfo.vatRegistered)
            || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice))
            ? this.shippingCost : (this.shippingCost + this.shippingTax);
    }

    /**
    * @description
    * @param {*} value
    * @memberof ServiceOrderComponent
    */
    updateProductInCart(value): void {
        this.updateCartProduct = value;
    }

    getUserMemberId() {
        let memberId = null;
        if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
            memberId = this.accountMemberInfo.memberId;
        } else
            memberId = 0

        return memberId;
    }

    /**
* @returns any
*/
    private getSessionGuid(): any {
        const uuid = SSO.getnonce();
        return uuid;;
    }
    /**
  * @description To get the order details based on sessionguid
  * @memberof ServiceOrderComponent
  */
    getOrderDetailsByUuid(orderSessionGuid: string, distrubutorId?: string) {
        if (orderSessionGuid) {
            this._orderService.getOrderDetailsUuid(orderSessionGuid, distrubutorId).subscribe((response: any) => {
                if (response) {
                    if (this.appConfig && this.appConfig.freeShippingFPCOrder && this.memberShippingDiscountOfferEligible) {
                        this.removeMemberDiscountOffer(this.memberInfo.memberId);
                    }
                    this.createOrderLog(response);
                    this.orderSuccess(response);
                    const sessionGuid = ((this.memberCart && this.memberCart.sessionGuid) || this.memberCartSessionGuid);
                    if (sessionGuid && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST && this.shoppingBagClicked) {
                        this.deleteCart(sessionGuid);
                    }
                }
                else {
                    const notification: any = this._translatePipe.get
                        ('order.Unable to Process Order.');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            }, (error: Response) => {
                const notification: any = this._translatePipe.get
                    ('order.Unable to Process Order.');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isSubmitted = false;
            });
        }
    }

    isEnableFboReferralId(): boolean {
        if (this.memberTypeId == MemberTypeEnum.GUEST && this.storeInfo && this.storeInfo.enableCspFBOReferralId && this.sponsorInformation) {
            return true;
        }
        return false;
    }

    /**
     * @description Method to search address based on name
     * @memberof ServiceOrderComponent
     */
    searchShippingAddress(event: any) {
        this.addressSearchResult = this._commonService.searchShippingAddress(event, this.memberAddressDetails);
    }

    displayParticipatingCountryAddress(address: Address) {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled
            && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP
            && address && address.countryCode && this.storeInfo.homeIsocodeThree) {
            return address.countryCode.toUpperCase() == this.storeInfo.homeIsocodeThree.toUpperCase()
        }
        return true;
    }

    getPudoLocationMap(geoPoint: GeoPoint) {
        if (geoPoint && geoPoint.latitude && geoPoint.longitude) {
            if(environment.restrictGoogleMapNavigation){
                return ApiUrlConstants.googleMapsUrl + geoPoint.latitude +
                ',' + geoPoint.longitude;
            }
            else {
                return null;
            }
        }
        return null;
    }

    getAgentAllowedCountries(): any {
        let agentAllowedCountries = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                this._customerService.getOperatingCountries().subscribe((response) => {
                    if (response) {
                        const countryIds = this.userInfo.allowedOperatingCountries.split(',');
                        agentAllowedCountries = response.filter(function (item) {
                            if (countryIds && countryIds.indexOf(item.id.toString()) > -1) {
                                return item;
                            }
                        });
                        if (agentAllowedCountries && agentAllowedCountries.length > 0) {
                            agentAllowedCountries = agentAllowedCountries.map(country => country.value);
                            this.agentAllowedCountries = JSON.parse(JSON.stringify(agentAllowedCountries));
                        }
                        if (this.memberInfo.memberAllowedCountries) {
                            this.populateCountries(this.memberInfo.memberAllowedCountries);
                        }
                    } else {
                        this.agentAllowedCountries = [];
                        if (this.memberInfo.memberAllowedCountries) {
                            this.populateCountries(this.memberInfo.memberAllowedCountries);
                        }
                    }
                });
            }
        } else if (this.memberInfo.memberAllowedCountries) {
            this.populateCountries(this.memberInfo.memberAllowedCountries);
        }
    }


    getPlaceOrderButtonEnabled() {
        let isEnablePlaceOrder: boolean;
        isEnablePlaceOrder = !((this.isActive)
            && ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
                && this.shippingAddressInfo && this.shippingAddressInfo.addressVerified)
                || ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP && this.shipMethod)
                    || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP
                        && this.pudoShippingMethod && this.selectedPudoCollectionPoint)
                    || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP &&
                        this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.selectedPudoCollectionPoint)))
            && (this.products.length > 0 && this.orderFormGroup.valid && this.service_Order_show) && !this.isSubmitted || (this.orderFormGroup.valid && this.verifyAddressButtonClicked));
        return isEnablePlaceOrder ? true : false;
    }

    getValidationForPlaceOrderbutton() {

        return !(this.isActive && ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
            && this.shippingAddressInfo && this.shippingAddressInfo.addressVerified) ||
            (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP &&
                ((this.shipMethod && !this.shippingAddressInfoConfig.pudoLocationsEnabled)
                    || (this.pudoShippingMethod && this.shippingAddressInfoConfig.pudoLocationsEnabled))))
            && this.products.length > 0 && (this.orderFormGroup.valid) && this.service_Order_show);

    }
    setPUDOSuggestedAddress() {
        this.pudoSuggestedAddressSubscription = this.messageService.getPUDOSuggestedAddress().subscribe((value) => {
            if (value) {
                this.buildPudoLocationSearchForm(value.zip, value.city, value.addressLine1);
                this.getPudoLocations();
            }
        });
    }
    ngOnDestroy(): void {
        if (this.pudoSuggestedAddressSubscription) {
            this.pudoSuggestedAddressSubscription.unsubscribe();
        }
        this._cacheService.remove(CacheKey.COUNTRY_CODE);
        this._cacheService.remove(CacheKey.COUNTRY_ID);
    }


    getMembergovernmentIdentificationsInfo(memberId: number) {
        if (memberId) {
            this._customerService.getMembergovernment_identifications(memberId).subscribe(response => {
                if (response) {
                    this.memberInfo.memberGovernmentIdentifications = response.memberGovernmentIdentificationModel;
                    this.memberInfo.vatDetailModel = response.vatDetailModel;
                }
            });
        }

    }

    clearTabStoreSetting() {
        this.homeCountry = null;
        this.countryCode = null;
        this.storeId = null;
        this.storeInfo = null;
        this.selectedIsoCountryCode = null;
    }

    

getDropShipPudoShippingMethods(shippingOptions: ShippingOptionsRequest, shippingMethods: ShippingMethod[], mappingRequired: boolean = true) {
    if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist)) {
        if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
            if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
        } else {
            shippingOptions.toAddress = this.getWarehouseAddress();
        }
        shippingOptions.shippingTypeId = ShippingType.DELIVERY;

        this._orderService.getShipmentService(shippingOptions).subscribe((response) => {
            if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                // Testing Purpose .
                //response.shippingMethods[0].pudoEnabled = true;
                this.dropshipPudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled);
                if (mappingRequired) {
                    if (this.dropshipPudoShippingMethod) {
                        this.dropshipPudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                    }
                }
            }
        }, (error) => {
        });
    }
}
}






// WEBPACK FOOTER //
// ./src/app/customerservice/components/service-order.component.ts